export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
};

export type ActiveLoan = {
  __typename?: "ActiveLoan";
  amount: Scalars["Float"];
  applicants: Maybe<Array<Applicant>>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  dealerFee: Scalars["Float"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  loanDocsSentAt: Maybe<Scalars["DateTime"]>;
  loanProductId: Scalars["String"];
  proposalId: Scalars["String"];
  /** the different loan providers for the activeLoan */
  provider: LoanProvider | `${LoanProvider}`;
  providerId: Scalars["String"];
  providerMetadata: Maybe<Scalars["JSON"]>;
  providerStatusEvents: Array<Scalars["JSON"]>;
  rate: Scalars["Float"];
  status: Maybe<ActiveLoanStatus | `${ActiveLoanStatus}`>;
  termMonths: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export enum ActiveLoanStatus {
  applied = "applied",
  approved = "approved",
  approved_with_stipulations = "approved_with_stipulations",
  denied = "denied",
  incomplete = "incomplete",
  loan_docs_sent = "loan_docs_sent",
}

export type Adder = {
  __typename?: "Adder";
  adderRoofingTypes: Maybe<Scalars["JSON"]>;
  adderWorkTypes: Maybe<Scalars["JSON"]>;
  addersListId: Scalars["String"];
  /** The category of the adder */
  category: Maybe<Scalars["JSON"]>;
  createdAt: Scalars["DateTime"];
  customPrice: Maybe<Scalars["Float"]>;
  customQuantity: Maybe<Scalars["Float"]>;
  deletedAt: Maybe<Scalars["DateTime"]>;
  doesMountingTypeRequireInstaller: Scalars["Boolean"];
  id: Scalars["ID"];
  isBaseCost: Scalars["Boolean"];
  isCustom: Scalars["Boolean"];
  isDesign: Scalars["Boolean"];
  isEquipment: Scalars["Boolean"];
  isGroundMount: Scalars["Boolean"];
  isInterconnect: Scalars["Boolean"];
  isInternal: Scalars["Boolean"];
  isLabor: Scalars["Boolean"];
  isMPU: Scalars["Boolean"];
  isPermit: Scalars["Boolean"];
  isRacking: Scalars["Boolean"];
  isSiteSurvey: Scalars["Boolean"];
  isTurnKey: Scalars["Boolean"];
  isVariable: Scalars["Boolean"];
  lineType: Maybe<Scalars["Float"]>;
  needsModuleCount: Scalars["Boolean"];
  powurOsCategoryId: Maybe<Scalars["Float"]>;
  powurOsId: Maybe<Scalars["Float"]>;
  priceList: Maybe<Scalars["JSON"]>;
  proposalType: Maybe<Scalars["Float"]>;
  relatedAdder: Maybe<Scalars["JSON"]>;
  relatedPowurOsAdderId: Maybe<Scalars["Float"]>;
  /** Whether or not the adder is included in cost calculations */
  selected: Scalars["Boolean"];
  /** The title of the adder */
  title: Scalars["String"];
  /** The unit for cost calculations of the adder  */
  unit: Maybe<Scalars["Float"]>;
  updatedAt: Scalars["DateTime"];
  watts: Maybe<Scalars["Float"]>;
};

export type AdderRegionAdder = {
  __typename?: "AdderRegionAdder";
  adderId: Scalars["Float"];
  adderRegionId: Scalars["Float"];
  id: Scalars["Float"];
  proposalType: Scalars["Float"];
};

export type AddersObject = {
  __typename?: "AddersObject";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  id: Scalars["ID"];
  items: Array<Adder>;
  /** Date until which pricing quotes are good, pricing must be refreshed after this date */
  pricingExpiresAt: Scalars["DateTime"];
  proposal: Proposal;
  proposalId: Scalars["String"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type Address = {
  city: Scalars["String"];
  state: StateCode | `${StateCode}`;
  street: Scalars["String"];
  zip: Scalars["String"];
};

export type AnalysisRate = {
  __typename?: "AnalysisRate";
  chargePeriod: Maybe<Scalars["String"]>;
  chargeType: Maybe<Scalars["String"]>;
  fromDateTime: Maybe<Scalars["String"]>;
  rateBands: Maybe<Array<AnalysisRateBand>>;
  scenarios: Maybe<Scalars["String"]>;
  toDateTime: Maybe<Scalars["String"]>;
};

export type AnalysisRateBand = {
  __typename?: "AnalysisRateBand";
  hasConsumptionLimit: Maybe<Scalars["String"]>;
  hasDemandLimit: Maybe<Scalars["String"]>;
  hasPropertyLimit: Maybe<Scalars["String"]>;
  isCredit: Maybe<Scalars["String"]>;
  rateAmount: Maybe<Scalars["String"]>;
  rateSequenceNumber: Maybe<Scalars["String"]>;
  rateUnit: Maybe<Scalars["String"]>;
  tariffRateBandId: Maybe<Scalars["String"]>;
  tariffRateId: Maybe<Scalars["String"]>;
};

export type AnalysisScenario = {
  __typename?: "AnalysisScenario";
  id: Maybe<Scalars["String"]>;
  inputs: Array<AnalysisScenarioInput>;
  name: Maybe<Scalars["String"]>;
  rates: Maybe<Array<AnalysisRate>>;
  serviceType: Maybe<Scalars["String"]>;
};

export type AnalysisScenarioInput = {
  __typename?: "AnalysisScenarioInput";
  dataType: Scalars["String"];
  dataValue: Scalars["String"];
  displayName: Maybe<Scalars["String"]>;
  fromDateTime: Maybe<Scalars["String"]>;
  keyName: Scalars["String"];
  operator: Maybe<Scalars["String"]>;
  scenarios: Scalars["String"];
  toDateTime: Maybe<Scalars["String"]>;
};

export type AnalysisSeries = {
  __typename?: "AnalysisSeries";
  cost: Maybe<Scalars["Float"]>;
  designId: Maybe<Scalars["String"]>;
  displayLabel: Maybe<Scalars["String"]>;
  fromDateTime: Maybe<Scalars["String"]>;
  key: Maybe<Scalars["String"]>;
  qty: Maybe<Scalars["Float"]>;
  rate: Maybe<Scalars["Float"]>;
  scenario: Maybe<Scalars["String"]>;
  seriesDuration: Maybe<Scalars["Float"]>;
  seriesId: Maybe<Scalars["Float"]>;
  seriesPeriod: Maybe<Scalars["String"]>;
  toDateTime: Maybe<Scalars["String"]>;
};

export type AnalysisSummary = {
  __typename?: "AnalysisSummary";
  lifeTimeUtilityAfterCost: Scalars["Float"];
  lifeTimeUtilityAvoidedRate: Scalars["Float"];
  lifetimeAvoidedCost: Scalars["Float"];
  lifetimeSolarCost: Scalars["Float"];
  lifetimeWithoutCost: Scalars["Float"];
  netAvoidedCost: Scalars["Float"];
  netAvoidedCostPctOffset: Scalars["Float"];
  netAvoidedKWh: Scalars["Float"];
  netAvoidedKWhPctOffset: Scalars["Float"];
  netAvoidedRate: Scalars["Float"];
  postTotalCost: Scalars["Float"];
  postTotalKWh: Scalars["Float"];
  postTotalKWhCost: Scalars["Float"];
  postTotalKWhRate: Scalars["Float"];
  postTotalMinCost: Scalars["Float"];
  postTotalNonBypassableCost: Scalars["Float"];
  postTotalNonMinCost: Scalars["Float"];
  postTotalRate: Scalars["Float"];
  preTotalCost: Scalars["Float"];
  preTotalKWh: Scalars["Float"];
  preTotalKWhCost: Scalars["Float"];
  preTotalKWhRate: Scalars["Float"];
  preTotalMinCost: Scalars["Float"];
  preTotalNonBypassableCost: Scalars["Float"];
  preTotalNonMinCost: Scalars["Float"];
  preTotalRate: Scalars["Float"];
};

export type ApiKey = {
  __typename?: "ApiKey";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  deactivatedAt: Maybe<Scalars["DateTime"]>;
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  serviceIntegrationId: Scalars["String"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type Applicability = {
  __typename?: "Applicability";
  applicabilityKey: Maybe<Scalars["String"]>;
  choices: Maybe<Array<Scalars["JSON"]>>;
  description: Maybe<Scalars["String"]>;
  displayName: Maybe<Scalars["String"]>;
  maxValue: Maybe<Scalars["Float"]>;
  minValue: Maybe<Scalars["Float"]>;
  operator: Maybe<Scalars["String"]>;
  quantityKey: Maybe<Scalars["String"]>;
  requiredValue: Maybe<Scalars["String"]>;
};

export type Applicant = {
  __typename?: "Applicant";
  activeLoanId: Maybe<Scalars["String"]>;
  annualIncome: Scalars["Float"];
  consentToShareInfo: Scalars["Boolean"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  email: Scalars["String"];
  employerName: Maybe<Scalars["String"]>;
  employmentMonths: Scalars["Float"];
  employmentYears: Scalars["Float"];
  firstName: Scalars["String"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  isCreditRun: Scalars["Boolean"];
  isPrimary: Scalars["Boolean"];
  jobTitle: Maybe<Scalars["String"]>;
  lastName: Scalars["String"];
  mailingCity: Maybe<Scalars["String"]>;
  mailingStateName: Maybe<Scalars["String"]>;
  mailingStreet: Maybe<Scalars["String"]>;
  mailingZipCode: Maybe<Scalars["String"]>;
  middleName: Maybe<Scalars["String"]>;
  otherPhone: Maybe<Scalars["String"]>;
  phone: Scalars["String"];
  residenceCity: Maybe<Scalars["String"]>;
  residenceStateName: Maybe<Scalars["String"]>;
  residenceStreet: Maybe<Scalars["String"]>;
  residenceZipCode: Maybe<Scalars["String"]>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  userId: Maybe<Scalars["String"]>;
};

export type ApplicantBodyResponse = {
  __typename?: "ApplicantBodyResponse";
  annualIncome: Scalars["Float"];
  consentToShareInfo: Scalars["Boolean"];
  email: Scalars["String"];
  employerName: Scalars["String"];
  employmentMonths: Scalars["Float"];
  employmentYears: Scalars["Float"];
  firstName: Scalars["String"];
  id: Scalars["String"];
  isCreditRun: Scalars["Boolean"];
  isPrimary: Scalars["Boolean"];
  jobTitle: Scalars["String"];
  lastName: Scalars["String"];
  mailingCity: Scalars["String"];
  mailingStateName: Scalars["String"];
  mailingStreet: Scalars["String"];
  mailingZipCode: Scalars["Float"];
  middleInitial: Scalars["String"];
  otherPhone: Scalars["Float"];
  phone: Scalars["Float"];
  residenceCity: Scalars["String"];
  residenceStateName: Scalars["String"];
  residenceStreet: Scalars["String"];
  residenceZipCode: Scalars["Float"];
};

export type ApplicantInput = {
  address: Address;
  annualIncome: CurrencyInput;
  citizenshipStatus: Citizenship_Status | `${Citizenship_Status}`;
  dob: Scalars["String"];
  electronicConsent: Scalars["Boolean"];
  email: Scalars["String"];
  employer?: InputMaybe<Scalars["String"]>;
  employmentDuration?: InputMaybe<Scalars["Float"]>;
  employmentStatus: Employment_Status | `${Employment_Status}`;
  firstName: Scalars["String"];
  homeOccupancy: Home_Occupancy | `${Home_Occupancy}`;
  homeOwnership: Home_Ownership | `${Home_Ownership}`;
  lastName: Scalars["String"];
  occupation: Scalars["String"];
  primaryPhoneNumber: Phone;
  secondaryPhoneNumber?: InputMaybe<Phone>;
  spokenLanguage: Spoken_Language | `${Spoken_Language}`;
  ssn: Scalars["String"];
};

export type ApplicantMessage = {
  __typename?: "ApplicantMessage";
  actualLoanAmount: Scalars["String"];
  borrowingLimit: Scalars["String"];
  expiration: Scalars["String"];
};

export type ApplicantSubmitCreditBody = {
  annualIncome?: InputMaybe<Scalars["Float"]>;
  consentToShareInfo?: InputMaybe<Scalars["Boolean"]>;
  dateOfBirth?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  employerName?: InputMaybe<Scalars["String"]>;
  employmentMonths?: InputMaybe<Scalars["Float"]>;
  employmentYears?: InputMaybe<Scalars["Float"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isCreditRun?: InputMaybe<Scalars["Boolean"]>;
  isPrimary?: InputMaybe<Scalars["Boolean"]>;
  jobTitle?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  mailingCity?: InputMaybe<Scalars["String"]>;
  mailingStateName?: InputMaybe<Scalars["String"]>;
  mailingStreet?: InputMaybe<Scalars["String"]>;
  mailingZipCode?: InputMaybe<Scalars["String"]>;
  middleInitial?: InputMaybe<Scalars["String"]>;
  otherPhone?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  residenceCity?: InputMaybe<Scalars["String"]>;
  residenceStateName?: InputMaybe<Scalars["String"]>;
  residenceStreet?: InputMaybe<Scalars["String"]>;
  residenceZipCode?: InputMaybe<Scalars["String"]>;
  ssn?: InputMaybe<Scalars["String"]>;
};

export type ApplicantSubmitCreditResponse = {
  __typename?: "ApplicantSubmitCreditResponse";
  annualIncome: Scalars["Float"];
  consentToShareInfo: Scalars["Boolean"];
  email: Scalars["String"];
  employerName: Scalars["String"];
  employmentMonths: Scalars["Float"];
  employmentYears: Scalars["Float"];
  firstName: Scalars["String"];
  id: Scalars["String"];
  isCreditRun: Scalars["Boolean"];
  isPrimary: Scalars["Boolean"];
  jobTitle: Scalars["String"];
  lastName: Scalars["String"];
  mailingCity: Scalars["String"];
  mailingStateName: Scalars["String"];
  mailingStreet: Scalars["String"];
  mailingZipCode: Scalars["String"];
  middleInitial: Scalars["String"];
  otherPhone: Scalars["String"];
  phone: Scalars["String"];
  residenceCity: Scalars["String"];
  residenceStateName: Scalars["String"];
  residenceStreet: Scalars["String"];
  residenceZipCode: Scalars["String"];
};

export type Attachment = {
  __typename?: "Attachment";
  extension: Scalars["String"];
  groupId: Scalars["String"];
  id: Scalars["String"];
  label: Scalars["String"];
  name: Scalars["String"];
  status: Scalars["String"];
  type: Scalars["String"];
};

export type BasicAdderAssociation = {
  __typename?: "BasicAdderAssociation";
  adderId: Scalars["Float"];
  equipmentId: Scalars["Float"];
};

export type Breakdown = {
  __typename?: "Breakdown";
  city_tax_collectable: Scalars["Float"];
  city_tax_rate: Scalars["Float"];
  city_taxable_amount: Scalars["Float"];
  combined_tax_rate: Scalars["Float"];
  country_tax_collectable: Scalars["Float"];
  country_tax_rate: Scalars["Float"];
  country_taxable_amount: Scalars["Float"];
  county_tax_collectable: Scalars["Float"];
  county_tax_rate: Scalars["Float"];
  county_taxable_amount: Scalars["Float"];
  gst: Scalars["Float"];
  gst_tax_rate: Scalars["Float"];
  gst_taxable_amount: Scalars["Float"];
  line_items: Array<BreakdownLineItems>;
  pst: Scalars["Float"];
  pst_tax_rate: Scalars["Float"];
  pst_taxable_amount: Scalars["Float"];
  qst: Scalars["Float"];
  qst_tax_rate: Scalars["Float"];
  qst_taxable_amount: Scalars["Float"];
  shipping: BreakdownShipping;
  special_district_tax_collectable: Scalars["Float"];
  special_district_taxable_amount: Scalars["Float"];
  special_tax_rate: Scalars["Float"];
  state_tax_collectable: Scalars["Float"];
  state_tax_rate: Scalars["Float"];
  state_taxable_amount: Scalars["Float"];
  tax_collectable: Scalars["Float"];
  taxable_amount: Scalars["Float"];
};

export type BreakdownLineItems = {
  __typename?: "BreakdownLineItems";
  city_amount: Scalars["Float"];
  city_tax_rate: Scalars["Float"];
  city_taxable_amount: Scalars["Float"];
  combined_tax_rate: Scalars["Float"];
  country_tax_collectable: Scalars["Float"];
  country_tax_rate: Scalars["Float"];
  country_taxable_amount: Scalars["Float"];
  county_amount: Scalars["Float"];
  county_tax_rate: Scalars["Float"];
  county_taxable_amount: Scalars["Float"];
  gst: Scalars["Float"];
  gst_tax_rate: Scalars["Float"];
  gst_taxable_amount: Scalars["Float"];
  id: Scalars["String"];
  pst: Scalars["Float"];
  pst_tax_rate: Scalars["Float"];
  pst_taxable_amount: Scalars["Float"];
  qst: Scalars["Float"];
  qst_tax_rate: Scalars["Float"];
  qst_taxable_amount: Scalars["Float"];
  special_district_amount: Scalars["Float"];
  special_district_taxable_amount: Scalars["Float"];
  special_tax_rate: Scalars["Float"];
  state_amount: Scalars["Float"];
  state_sales_tax_rate: Scalars["Float"];
  state_taxable_amount: Scalars["Float"];
  tax_collectable: Scalars["Float"];
  taxable_amount: Scalars["Float"];
};

export type BreakdownShipping = {
  __typename?: "BreakdownShipping";
  city_amount: Scalars["Float"];
  city_tax_rate: Scalars["Float"];
  city_taxable_amount: Scalars["Float"];
  combined_tax_rate: Scalars["Float"];
  county_amount: Scalars["Float"];
  county_tax_rate: Scalars["Float"];
  county_taxable_amount: Scalars["Float"];
  special_district_amount: Scalars["Float"];
  special_tax_rate: Scalars["Float"];
  special_taxable_amount: Scalars["Float"];
  state_amount: Scalars["Float"];
  state_sales_tax_rate: Scalars["Float"];
  state_taxable_amount: Scalars["Float"];
  tax_collectable: Scalars["Float"];
  taxable_amount: Scalars["Float"];
};

/** Goodleap Citizenship Status Type */
export enum Citizenship_Status {
  LAWFUL_PERMANENT_RESIDENT_ALIEN = "LAWFUL_PERMANENT_RESIDENT_ALIEN",
  OTHER = "OTHER",
  US_CITIZEN = "US_CITIZEN",
}

export type CoApplicant = {
  address?: InputMaybe<Address>;
  annualIncome: CurrencyInput;
  citizenshipStatus: Citizenship_Status | `${Citizenship_Status}`;
  dob: Scalars["String"];
  electronicConsent: Scalars["Boolean"];
  email: Scalars["String"];
  employer?: InputMaybe<Scalars["String"]>;
  employmentDuration?: InputMaybe<Scalars["Float"]>;
  employmentStatus: Employment_Status | `${Employment_Status}`;
  firstName: Scalars["String"];
  homeOccupancy: Home_Occupancy | `${Home_Occupancy}`;
  homeOwnership: Home_Ownership | `${Home_Ownership}`;
  lastName: Scalars["String"];
  occupation: Scalars["String"];
  primaryPhoneNumber?: InputMaybe<Phone>;
  secondaryPhoneNumber?: InputMaybe<Phone>;
  spokenLanguage: Spoken_Language | `${Spoken_Language}`;
  ssn: Scalars["String"];
};

export enum ContentType {
  JPEG = "JPEG",
  JPG = "JPG",
  PDF = "PDF",
  PNG = "PNG",
}

export type Contract = {
  __typename?: "Contract";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  dateSent: Maybe<Scalars["DateTime"]>;
  dateSentToPowurOs: Maybe<Scalars["DateTime"]>;
  dateSigned: Maybe<Scalars["DateTime"]>;
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  envelopeId: Scalars["String"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  proposalId: Scalars["String"];
  systemSize: Maybe<Scalars["Float"]>;
  totalCost: Maybe<Scalars["Float"]>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type CostSummary = {
  __typename?: "CostSummary";
  adjustedTotalCost: Maybe<Scalars["Float"]>;
  kW: Maybe<Scalars["Float"]>;
  kWh: Maybe<Scalars["Float"]>;
  subTotalCost: Maybe<Scalars["Float"]>;
  taxCost: Maybe<Scalars["Float"]>;
  totalCost: Maybe<Scalars["Float"]>;
};

export type CreateProposalAuditInput = {
  eventType: ProposalAuditEventType | `${ProposalAuditEventType}`;
  proposalId: Scalars["String"];
  result: Scalars["Float"];
  searchParams: Array<Scalars["String"]>;
  updatedById: Scalars["String"];
};

export type CreateProposalStatusInput = {
  message: Scalars["String"];
  proposalId: Scalars["String"];
};

export type CreateSavingsAnalysisDto = {
  __typename?: "CreateSavingsAnalysisDto";
  accountId: Scalars["String"];
  autoBaseline: Scalars["Boolean"];
  fromDateTime: Scalars["String"];
  populateCosts: Maybe<Scalars["Boolean"]>;
  propertyInputs: Array<SavingsPropertyInputs>;
  providerAccountId: Maybe<Scalars["String"]>;
  rateInputs: Maybe<Array<SavingsRateInputs>>;
  tariffEffectiveOn: Maybe<Scalars["String"]>;
  useIntelligentBaselining: Scalars["Boolean"];
};

export type CreateServiceIntegrationInput = {
  contactEmail: Scalars["String"];
  contactName: Scalars["String"];
  name: Scalars["String"];
};

export type CreateSiteInput = {
  /** Address of the site */
  address: Scalars["String"];
  /** Latitude of the site */
  latitude: Scalars["Float"];
  /** Longitude of the site */
  longitude: Scalars["Float"];
  /** street view latitude of the site */
  streetViewLatitude: Scalars["Float"];
  /** Street view longitude of the site */
  streetViewLongitude: Scalars["Float"];
};

export type CreateUserInput = {
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  powurUserId?: InputMaybe<Scalars["Float"]>;
  roles: Array<UserRole | `${UserRole}`>;
};

export type CreditsSubmitCreditResponse = {
  __typename?: "CreditsSubmitCreditResponse";
  applicantFirstName: Scalars["String"];
  applicantId: Scalars["String"];
  applicantLastName: Scalars["String"];
  creditBureau: Scalars["String"];
  creditDecisionDate: Scalars["String"];
  creditExpirationDate: Scalars["String"];
  creditExtensionStatus: Scalars["String"];
  hashId: Scalars["String"];
  id: Scalars["String"];
  inPersonSigningEligible: Scalars["Boolean"];
  isCounterOffer: Scalars["Boolean"];
  isHICounterOffer: Scalars["Boolean"];
  isSyncing: Scalars["Boolean"];
  ltFNIDecision: Scalars["String"];
  maxApprovedAmount: Scalars["Float"];
  name: Scalars["String"];
  originalCoBorrowerDropped: Scalars["Boolean"];
  originalPrimaryDropped: Scalars["Boolean"];
  originalRequestedLoanAmount: Scalars["Float"];
  posMessageEmail: Scalars["String"];
  posMessageEmailMobile: Scalars["String"];
  productId: Scalars["String"];
  productMaxLoanAmount: Scalars["String"];
  productMinLoanAmount: Scalars["String"];
  productName: Scalars["String"];
  solarRBPCounterOffer: Scalars["Boolean"];
  status: Scalars["String"];
  stipReason: Scalars["String"];
  stipText: Scalars["String"];
};

export type Currency = {
  __typename?: "Currency";
  type: Scalars["String"];
  value: Scalars["Float"];
};

export type CurrencyInput = {
  type: Scalars["String"];
  value: Scalars["Float"];
};

export type Decision = {
  __typename?: "Decision";
  applicantMessages: ApplicantMessage;
  creditApplicationId: Scalars["String"];
  description: Scalars["String"];
  expires: Scalars["String"];
  financingProducts: Array<FinancingProduct>;
  result: Scalars["String"];
  status: Scalars["String"];
  updated: Scalars["String"];
};

export type Design = {
  __typename?: "Design";
  activatedAt: Maybe<Scalars["DateTime"]>;
  batteryCompatibility: Scalars["Boolean"];
  brochurePositionX: Scalars["Float"];
  brochurePositionY: Scalars["Float"];
  brochureZoom: Scalars["Float"];
  completedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  deletedAt: Maybe<Scalars["DateTime"]>;
  displayImageryProvider: ImagerySource | `${ImagerySource}`;
  docs: Maybe<Array<Doc>>;
  edges: Scalars["JSON"];
  energyBackup: Maybe<Equipment>;
  energyBackupId: Maybe<Scalars["String"]>;
  energyEfficiencyKitRebate: Scalars["Boolean"];
  energyEfficiencyKitRebateAmount: Scalars["Float"];
  estimates: Maybe<Array<Estimate>>;
  evCharger: Scalars["Boolean"];
  evOutlet: Scalars["Boolean"];
  homeownerJwt: Maybe<Scalars["String"]>;
  homeownerRebate: Scalars["Boolean"];
  homeownerRebateAmount: Scalars["Float"];
  id: Scalars["ID"];
  installAreas: Scalars["JSON"];
  installAreasToPanels: Scalars["JSON"];
  inverter: Maybe<Equipment>;
  inverterId: Maybe<Scalars["String"]>;
  inverterManufacturer: Maybe<Scalars["String"]>;
  jwtExpiresAt: Maybe<Scalars["DateTime"]>;
  nodes: Scalars["JSON"];
  obstructions: Scalars["JSON"];
  panels: Scalars["JSON"];
  phase: Scalars["String"];
  powurCareThirtyYearWarranty: Scalars["Boolean"];
  proposal: Maybe<Proposal>;
  proposalId: Scalars["ID"];
  relatedEquipment: Array<RelatedEquipmentObject>;
  roofWorkRebate: Scalars["Boolean"];
  roofWorkRebateAmount: Scalars["Float"];
  savings: Maybe<Savings>;
  secondaryInverter: Maybe<Equipment>;
  secondaryInverterId: Maybe<Scalars["String"]>;
  setbacks: Scalars["JSON"];
  shadingAreas: Scalars["JSON"];
  solarEdgeTwentyFiveYearWarranty: Scalars["Boolean"];
  solarEdgeTwentyFiveYearWarrantyPrice: Scalars["Float"];
  solarEdgeTwentyYearWarranty: Scalars["Boolean"];
  solarEdgeTwentyYearWarrantyPrice: Scalars["Float"];
  solarModule: Maybe<Equipment>;
  solarModuleId: Maybe<Scalars["String"]>;
  sunroofCheckedAt: Maybe<Scalars["DateTime"]>;
  tool: Scalars["String"];
  treeTrimmingRebate: Scalars["Boolean"];
  treeTrimmingRebateAmount: Scalars["Float"];
  type: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type DesignFindManyWhereInput = {
  before?: InputMaybe<Scalars["DateTime"]>;
  designerId?: InputMaybe<Scalars["ID"]>;
  homeownerId?: InputMaybe<Scalars["ID"]>;
  proposalId?: InputMaybe<Scalars["ID"]>;
  sellerId?: InputMaybe<Scalars["ID"]>;
  since?: InputMaybe<Scalars["DateTime"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type DesignNote = {
  __typename?: "DesignNote";
  createdAt: Scalars["DateTime"];
  createdBy: User;
  createdById: Scalars["String"];
  deletedAt: Maybe<Scalars["DateTime"]>;
  design: Design;
  designId: Scalars["String"];
  designRequest: DesignRequest;
  designRequestId: Scalars["String"];
  id: Scalars["String"];
  message: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type DesignOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>;
  id?: InputMaybe<SortOrder | `${SortOrder}`>;
  proposalId?: InputMaybe<SortOrder | `${SortOrder}`>;
  type?: InputMaybe<SortOrder | `${SortOrder}`>;
  updatedAt?: InputMaybe<SortOrder | `${SortOrder}`>;
};

export type DesignRequest = {
  __typename?: "DesignRequest";
  completedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  deletedAt: Maybe<Scalars["DateTime"]>;
  design: Design;
  designId: Scalars["String"];
  designNotes: Array<DesignNote>;
  designUser: Maybe<DesignUser>;
  designUserId: Maybe<Scalars["String"]>;
  enterprise: Maybe<Enterprise>;
  enterpriseId: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  priority: Scalars["Float"];
  promisedAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export type DesignUser = {
  __typename?: "DesignUser";
  completedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  deletedAt: Maybe<Scalars["DateTime"]>;
  design: Design;
  designId: Scalars["String"];
  designNotes: Array<DesignNote>;
  designRequests: Array<DesignRequest>;
  id: Scalars["String"];
  startedAt: Maybe<Scalars["DateTime"]>;
  updatedAt: Scalars["DateTime"];
  user: User;
  userId: Scalars["String"];
};

export type DesignsInput = {
  filter?: InputMaybe<DesignFindManyWhereInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<DesignOrderByInput>;
};

export type Doc = {
  __typename?: "Doc";
  content: Scalars["String"];
  createdAt: Scalars["DateTime"];
  deletedAt: Maybe<Scalars["DateTime"]>;
  docType: Scalars["String"];
  id: Scalars["ID"];
  location: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type Document = {
  __typename?: "Document";
  description: Scalars["String"];
  name: Scalars["String"];
  type: Scalars["String"];
};

/** Goodleap Employment Status Type */
export enum Employment_Status {
  EMPLOYED = "EMPLOYED",
  NOT_EMPLOYED = "NOT_EMPLOYED",
  OTHER = "OTHER",
  RETIRED = "RETIRED",
}

export type Enterprise = {
  __typename?: "Enterprise";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  logo: Maybe<Logo>;
  name: Scalars["String"];
  owner: User;
  ownerId: Scalars["String"];
  powurId: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type Equipment = {
  __typename?: "Equipment";
  basicAdderAssociations: Array<BasicAdderAssociation>;
  catalogNumber: Maybe<Scalars["String"]>;
  cecWeightedEfficiency: Scalars["Float"];
  childEquipmentAssociations: Scalars["JSON"];
  compatibleInverterManufacturers: Array<PowurOsManufacturer>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  currentProposalPrice: Scalars["Float"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  description: Maybe<Scalars["String"]>;
  equipmentDocuments: Scalars["JSON"];
  equipmentRegions: Maybe<Array<EquipmentRegion>>;
  equipmentType: EquipmentType;
  equipmentTypeId: Scalars["String"];
  height: Maybe<Scalars["Float"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  inverterData: Maybe<Scalars["JSON"]>;
  manufacturer: Manufacturer;
  manufacturerId: Scalars["String"];
  marketingPdfUrl: Maybe<Scalars["String"]>;
  moduleData: Maybe<Scalars["JSON"]>;
  name: Scalars["String"];
  parentEquipmentAssociations: Scalars["JSON"];
  powurOsEquipmentTypeId: Scalars["Float"];
  powurOsId: Scalars["Float"];
  powurOsInverterDataId: Maybe<Scalars["Float"]>;
  powurOsManufacturerId: Scalars["Float"];
  powurOsModuleDataId: Maybe<Scalars["Float"]>;
  powurOwned: Scalars["Boolean"];
  proposalPrices: Array<Scalars["JSON"]>;
  sunnovaAccepted: Scalars["Boolean"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  warranty: Maybe<Scalars["JSON"]>;
  wattage: Maybe<Scalars["Float"]>;
  width: Maybe<Scalars["Float"]>;
};

export type EquipmentRegion = {
  __typename?: "EquipmentRegion";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  equipmentId: Scalars["String"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  isDefault: Scalars["Boolean"];
  powurOsEquipmentId: Scalars["Float"];
  powurOsRegionId: Scalars["Float"];
  powurOsStatusId: Scalars["Float"];
  powurOsTaxStatusId: Maybe<Scalars["Float"]>;
  region: Maybe<Region>;
  regionId: Scalars["String"];
  status: Scalars["JSON"];
  taxStatus: Maybe<TaxStatus>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type EquipmentType = {
  __typename?: "EquipmentType";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  equipment: Maybe<Array<Equipment>>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  name: Scalars["String"];
  powurOsId: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type Estimate = {
  __typename?: "Estimate";
  /** Annual AC system output. (kWhac) */
  acAnnual: Scalars["Float"];
  /** Monthly AC system output. (kWhac).  The array of values represents the value for each month, with the first element being for January and the last element being for December. */
  acMonthly: Maybe<Array<Scalars["Float"]>>;
  /** The ratio of the system's predicted electrical output in the first year of operation to the nameplate output, which is equivalent to the quantity of energy the system would generate if it operated at its nameplate capacity for every hour of the year. (AC-to-DC) */
  capacityFactor: Scalars["Float"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** Monthly DC array output. (kWhdc). The array of values represents the value for each month, with the first element being for January and the last element being for December. */
  dcMonthly: Array<Scalars["Float"]>;
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** The ID of the associated design */
  designId: Scalars["String"];
  /** Any error messages resulting from the request. */
  errors: Maybe<Array<Scalars["String"]>>;
  genabilitySolarProfileId: Maybe<Scalars["String"]>;
  /** The ID of the estimate. */
  id: Scalars["ID"];
  /** Inputs used to make the request to PvWatts API */
  inputs: Maybe<PvWatts_Inputs>;
  /** The ID of the associated install area */
  installAreaId: Scalars["String"];
  /** Monthly plane of array irradiance values. (kWh/m2).  The array of values represents the value for each month, with the first element being for January and the last element being for December. */
  poaMonthly: Array<Scalars["Float"]>;
  /** Annual solar radiation values. (kWh/m2/day) */
  solradAnnual: Scalars["Float"];
  /** Monthly solar radiation values. (kWh/m2/day) The array of values represents the value for each month, with the first element being for January and the last element being for December. */
  solradMonthly: Array<Scalars["Float"]>;
  /** Information about the SSC library. */
  sscInfo: Maybe<SscInfo>;
  /** Information about the climate data used in the simulation. */
  stationInfo: Maybe<StationInfo>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type FinancingProduct = {
  __typename?: "FinancingProduct";
  id: Scalars["String"];
  maxBorrowingAmount: Scalars["Float"];
  minBorrowingAmount: Scalars["Float"];
  name: Scalars["String"];
};

export type FindEstimateInput = {
  id?: InputMaybe<Scalars["ID"]>;
  installAreaId?: InputMaybe<Scalars["ID"]>;
};

export type FindProposalInput = {
  /** Proposal ID */
  id?: InputMaybe<Scalars["String"]>;
  /** Proposal unique slug */
  slug?: InputMaybe<Scalars["String"]>;
};

export type GetDisclosuresByLoanProductIdResponse =
  | GoodLeapGetDisclosuresResponseDto
  | MosaicGetDisclosuresResponseDto
  | SunlightGetDisclosuresResponse;

export type GetSunlightIframeUrlDto = {
  loanProductId: Scalars["String"];
  proposalId: Scalars["String"];
};

export type GetUtilityBillUploadUrlInput = {
  /** what to call the file */
  fileName: Scalars["String"];
  /** MIME content type */
  fileType: ContentType | `${ContentType}`;
  /** ID for proposal getting upload URL */
  proposalId: Scalars["String"];
};

export type GoodLeapCreateLoanRequestDto = {
  amount: CurrencyInput;
  applicant: ApplicantInput;
  applicantSignature: Scalars["String"];
  categoryId: Scalars["String"];
  channel: Scalars["String"];
  coApplicant?: InputMaybe<CoApplicant>;
  disclosureToken: Scalars["String"];
  enrollments: Array<Scalars["String"]>;
  offerId: Scalars["String"];
  referenceNumber?: InputMaybe<Scalars["String"]>;
  subjectProperty: SubjectProperty;
  submittingUser: SubmittingUser;
};

export type GoodLeapCreateLoanResponseDto = {
  __typename?: "GoodLeapCreateLoanResponseDto";
  approvedLoanAmount: Currency;
  id: Scalars["String"];
  offerId: Scalars["String"];
  referenceNumber: Scalars["String"];
  requestedLoanAmount: Currency;
  sentLoanDocuments: Scalars["Boolean"];
  status: Scalars["String"];
  stipulations: Array<Stipulation>;
  type: Scalars["String"];
};

export type GoodLeapDisclosuresDataArrayDto = {
  __typename?: "GoodLeapDisclosuresDataArrayDto";
  current: Scalars["Boolean"];
  id: Scalars["String"];
  meta: GoodLeapDisclosuresMetaObjectDto;
  name: Scalars["String"];
  sections: Array<GoodLeapDisclosuresSectionArrayDto>;
  token: Scalars["String"];
  tokenExpiresAt: Scalars["String"];
};

export type GoodLeapDisclosuresMetaObjectDto = {
  __typename?: "GoodLeapDisclosuresMetaObjectDto";
  cursor: Maybe<Scalars["String"]>;
};

export type GoodLeapDisclosuresSectionArrayDto = {
  __typename?: "GoodLeapDisclosuresSectionArrayDto";
  boldText: Scalars["Boolean"];
  checkbox: Scalars["Boolean"];
  signatureBox: Scalars["Boolean"];
  sort: Scalars["Float"];
  text: Scalars["String"];
};

export type GoodLeapGetDisclosuresResponseDto = {
  __typename?: "GoodLeapGetDisclosuresResponseDto";
  data: Array<GoodLeapDisclosuresDataArrayDto>;
  links: GoodleapDisclosuresLinks;
};

export type GoodleapAmount = {
  __typename?: "GoodleapAmount";
  type: Maybe<Scalars["String"]>;
  value: Maybe<Scalars["Float"]>;
};

export type GoodleapAttachment = {
  __typename?: "GoodleapAttachment";
  extension: Maybe<Scalars["String"]>;
  groupId: Maybe<Scalars["String"]>;
  id: Maybe<Scalars["String"]>;
  label: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  status: Maybe<Scalars["String"]>;
  type: Maybe<Scalars["String"]>;
};

export type GoodleapCalculation = {
  __typename?: "GoodleapCalculation";
  amount: GoodleapAmount;
  interval: Scalars["String"];
  paydownAmount: Maybe<GoodleapAmount>;
  paymentDescription: Maybe<Scalars["String"]>;
  roundedAmount: GoodleapAmount;
  type: Scalars["String"];
};

export type GoodleapDisclosuresLinks = {
  __typename?: "GoodleapDisclosuresLinks";
  next: Maybe<Scalars["String"]>;
  prev: Maybe<Scalars["String"]>;
};

export type GoodleapDocumentsToClear = {
  __typename?: "GoodleapDocumentsToClear";
  description: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  type: Maybe<Scalars["String"]>;
};

export type GoodleapLoanResponse = {
  __typename?: "GoodleapLoanResponse";
  approvedLoanAmount: Maybe<GoodleapAmount>;
  id: Maybe<Scalars["String"]>;
  offerId: Maybe<Scalars["String"]>;
  referenceNumber: Maybe<Scalars["String"]>;
  requestedLoanAmount: Maybe<GoodleapAmount>;
  sentLoanDocuments: Maybe<Scalars["Boolean"]>;
  status: Maybe<Scalars["String"]>;
  stipulations: Maybe<Array<GoodleapStipulations>>;
  type: Maybe<Scalars["String"]>;
};

export type GoodleapPaymentsResponse = {
  __typename?: "GoodleapPaymentsResponse";
  calculations: Array<GoodleapCalculation>;
  disclaimerText: Maybe<Scalars["String"]>;
  loanAmount: GoodleapAmount;
  offerId: Scalars["String"];
};

export type GoodleapStipulations = {
  __typename?: "GoodleapStipulations";
  appliesTo: Maybe<Scalars["String"]>;
  attachments: Maybe<Array<GoodleapAttachment>>;
  createdAt: Maybe<Scalars["String"]>;
  deferred: Maybe<Scalars["Boolean"]>;
  description: Maybe<Scalars["String"]>;
  documentsToClear: Maybe<Array<GoodleapDocumentsToClear>>;
  domain: Maybe<Scalars["String"]>;
  id: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  reasonCodes: Maybe<Array<Scalars["String"]>>;
  status: Maybe<Scalars["String"]>;
  type: Maybe<Scalars["String"]>;
  updatedAt: Maybe<Scalars["String"]>;
  updatedBy: Maybe<Scalars["String"]>;
};

/** Goodleap Home Type */
export enum Home_Occupancy {
  INVESTMENT = "INVESTMENT",
  OTHER = "OTHER",
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

/** Goodleap Home Ownership Type */
export enum Home_Ownership {
  NOT_OWNED = "NOT_OWNED",
  OWNED_FREE_AND_CLEAR = "OWNED_FREE_AND_CLEAR",
  OWNED_WITH_MORTGAGE = "OWNED_WITH_MORTGAGE",
}

export type ImageSizes = {
  __typename?: "ImageSizes";
  large: Maybe<Scalars["String"]>;
  original: Maybe<Scalars["String"]>;
  preview: Maybe<Scalars["String"]>;
  retina: Maybe<Scalars["String"]>;
  thumb: Maybe<Scalars["String"]>;
};

export type Imagery = {
  __typename?: "Imagery";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  fetchError: Maybe<Scalars["String"]>;
  filename: Maybe<Scalars["String"]>;
  height: Maybe<Scalars["Float"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  imageDate: Maybe<Scalars["String"]>;
  /** Audit events for this imagery */
  imageryAudits: Array<ImageryAudit>;
  positionedX: Maybe<Scalars["Float"]>;
  positionedY: Maybe<Scalars["Float"]>;
  positionedZoom: Maybe<Scalars["Float"]>;
  /** The site this imagery belongs to */
  site: Site;
  siteId: Scalars["ID"];
  source: ImagerySource | `${ImagerySource}`;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  width: Maybe<Scalars["Float"]>;
  zoomLevel: Maybe<Scalars["Float"]>;
};

export type ImageryAudit = {
  __typename?: "ImageryAudit";
  /** cached image location */
  cachedImageUrl: Maybe<Scalars["String"]>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** error text for audit failure */
  errorText: Maybe<Scalars["String"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** imagery related to audit */
  imagery: Imagery;
  /** full image request URL, with parameters */
  requestUrl: Scalars["String"];
  /** query response status code */
  responseStatus: Scalars["Float"];
  /** service provider */
  serviceProvider: ImagerySource | `${ImagerySource}`;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type ImageryFetchError = {
  __typename?: "ImageryFetchError";
  fetchError: Scalars["String"];
  source: Scalars["String"];
};

export type ImageryFetchSuccess = {
  __typename?: "ImageryFetchSuccess";
  filename: Scalars["String"];
  height: Maybe<Scalars["Float"]>;
  imageDate: Maybe<Scalars["String"]>;
  positionedX: Maybe<Scalars["Float"]>;
  positionedY: Maybe<Scalars["Float"]>;
  positionedZoom: Maybe<Scalars["Float"]>;
  source: Scalars["String"];
  width: Maybe<Scalars["Float"]>;
  zoomLevel: Maybe<Scalars["Float"]>;
};

export type ImageryResult = ImageryFetchError | ImageryFetchSuccess;

export enum ImagerySource {
  bing = "bing",
  google = "google",
  nearmap = "nearmap",
  pictometry = "pictometry",
}

export type Incentive = {
  __typename?: "Incentive";
  applicabilities: Array<Applicability>;
  applyToLoan: Scalars["Boolean"];
  createdAt: Scalars["DateTime"];
  customerClass: Maybe<Scalars["String"]>;
  deletedAt: Maybe<Scalars["DateTime"]>;
  documents: Maybe<Scalars["String"]>;
  eligibility: Scalars["String"];
  /** YYYY-MM-DD */
  endDate: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  incentiveId: Scalars["Float"];
  incentiveName: Maybe<Scalars["String"]>;
  incentivePaidTo: Maybe<Scalars["String"]>;
  incentiveType: Maybe<Scalars["String"]>;
  isExhausted: Maybe<Scalars["Boolean"]>;
  /** The entity type that offers this incentive. In the case of a tax credit, this is also used to determine if the incentive applies to state or federal taxes. */
  jurisdiction: Maybe<Scalars["String"]>;
  lseCode: Maybe<Scalars["String"]>;
  lseId: Maybe<Scalars["Float"]>;
  lseName: Maybe<Scalars["String"]>;
  masterIncentiveId: Scalars["Float"];
  paymentCap: Maybe<Scalars["Float"]>;
  paymentDuration: Maybe<Scalars["Float"]>;
  percentCostCap: Maybe<Scalars["Float"]>;
  percentCostCapKey: Maybe<PropertyKey>;
  projectType: Maybe<Scalars["String"]>;
  /** Indicates if more than one incentive from this LSE/jurisdiction can be used for a customer for this projectType. True means only one incentive from the LSE/jurisdiction can be used. False means more than one incentive from the LSE/jurisdiction can be used. */
  projectTypeExclusive: Maybe<Scalars["Boolean"]>;
  proposalId: Scalars["String"];
  quantityKey: Maybe<PropertyKey>;
  /** The maximum quantity key (e.g. systemSizeAc) that is eligible for this incentive. For example, if quantityKey=systemSizeAc, the value of this field is 50, and the system size is 60, then the first 50 kW of the system is eligible for the incentive. */
  quantityKeyCap: Maybe<Scalars["String"]>;
  rate: Maybe<Scalars["Float"]>;
  rateUnit: Maybe<Scalars["String"]>;
  requiredData: Maybe<Applicability>;
  /** Free text field describing the requirements for the incentive. Designed to be used in a user interface to give an overview of incentive’s requirements. */
  requirements: Maybe<Scalars["String"]>;
  serviceType: Maybe<Scalars["String"]>;
  showOnBrochure: Scalars["Boolean"];
  /** YYYY-MM-DD */
  startDate: Scalars["String"];
  state: Maybe<Scalars["String"]>;
  /** Free text field describing the incentive. Designed to be used in a user interface as a general overview. */
  summary: Maybe<Scalars["String"]>;
  tariffCode: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type LoanProduct = {
  __typename?: "LoanProduct";
  activatedAt: Maybe<Scalars["DateTime"]>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  maximumLoanAmount: Maybe<Scalars["Float"]>;
  minimumCreditScore: Maybe<Scalars["Float"]>;
  minimumLoanAmount: Maybe<Scalars["Float"]>;
  productName: Maybe<Scalars["String"]>;
  provider: LoanProvider | `${LoanProvider}`;
  providerFee: Maybe<Scalars["Float"]>;
  /** Unique id generated by loan provider */
  providerId: Scalars["String"];
  providerMeta: Maybe<Scalars["JSON"]>;
  providerName: Maybe<Scalars["String"]>;
  rate: Scalars["Float"];
  /** States that this loan product is active in */
  statesActive: Array<StateCode | `${StateCode}`>;
  /** States that this loan product can be active in */
  statesPossible: Array<StateCode | `${StateCode}`>;
  term: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type LoanProductFindManyWhereInput = {
  provider?: InputMaybe<LoanProvider | `${LoanProvider}`>;
  search?: InputMaybe<Scalars["String"]>;
};

export type LoanProductsInput = {
  filter?: InputMaybe<LoanProductFindManyWhereInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<LoanProductsOrderByInput>;
};

export type LoanProductsOrderByInput = {
  productName?: InputMaybe<SortOrder | `${SortOrder}`>;
  provider?: InputMaybe<SortOrder | `${SortOrder}`>;
  providerName?: InputMaybe<SortOrder | `${SortOrder}`>;
  rate?: InputMaybe<SortOrder | `${SortOrder}`>;
  term?: InputMaybe<SortOrder | `${SortOrder}`>;
};

export enum LoanProvider {
  goodleap = "goodleap",
  mosaic = "mosaic",
  sunlight = "sunlight",
}

export type Logo = {
  __typename?: "Logo";
  bucket: Scalars["String"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  key: Scalars["String"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type Manufacturer = {
  __typename?: "Manufacturer";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  name: Scalars["String"];
  powurOsId: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type MosaicAddressDto = {
  city: Scalars["String"];
  stateAbbreviation: StateCode | `${StateCode}`;
  street: Scalars["String"];
  zipCode: Scalars["String"];
};

export type MosaicApplicantDto = {
  annualIncome: Scalars["Float"];
  dateOfBirth: Scalars["String"];
  disclosuresAccepted: Array<MosaicDisclosuresAcceptedDto>;
  emailAddress: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  middleName?: InputMaybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  primaryAddress: MosaicAddressDto;
  socialSecurityNumber: Scalars["String"];
};

export type MosaicApplicationDto = {
  __typename?: "MosaicApplicationDto";
  id: Scalars["String"];
  status: Scalars["String"];
};

export type MosaicCreateNewUserBodyDto = {
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  partnerIdentifier: Scalars["String"];
  phoneNumber: Scalars["String"];
  role: Scalars["String"];
  status: Scalars["String"];
};

export type MosaicDisclosuresAcceptedDto = {
  assetCode: Scalars["String"];
  version: Scalars["String"];
};

export type MosaicDisclosuresArrayDto = {
  __typename?: "MosaicDisclosuresArrayDto";
  assetCode: Maybe<Scalars["String"]>;
  assetType: Scalars["String"];
  contents: Array<MosaicDisclosuresContentArrayDto>;
  scope: Scalars["String"];
  title: Scalars["String"];
  version: Scalars["String"];
};

export type MosaicDisclosuresContentArrayDto = {
  __typename?: "MosaicDisclosuresContentArrayDto";
  contentType: Scalars["String"];
  data: Scalars["String"];
  title: Scalars["String"];
};

export type MosaicGetApplicationResponseDto = {
  __typename?: "MosaicGetApplicationResponseDto";
  decision: Decision;
  externalId: Scalars["String"];
  id: Scalars["String"];
  salesRepExternalIdentifier: Scalars["String"];
  salesRepIdentifier: Scalars["String"];
  status: Scalars["String"];
};

export type MosaicGetDisclosuresBodyDto = {
  category: Scalars["String"];
  combined: Scalars["Boolean"];
  format: Scalars["String"];
  language: Scalars["String"];
  tag: Scalars["String"];
};

export type MosaicGetDisclosuresResponseDto = {
  __typename?: "MosaicGetDisclosuresResponseDto";
  bundleId: Scalars["String"];
  disclosures: Array<MosaicDisclosuresArrayDto>;
};

export type MosaicGetLoginsResponseDto = {
  __typename?: "MosaicGetLoginsResponseDto";
  email: Scalars["String"];
  firstName: Scalars["String"];
  id: Scalars["String"];
  lastName: Scalars["String"];
  partnerIdentifier: Scalars["String"];
  role: Scalars["String"];
  status: Scalars["String"];
};

export type MosaicGetUsersBodyDto = {
  after?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["String"]>;
  partnerIdentifier?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export type MosaicGetUsersResponseDto = {
  __typename?: "MosaicGetUsersResponseDto";
  links: Maybe<MosaicGetUsersResponseLinksDto>;
  logins: Array<MosaicGetLoginsResponseDto>;
};

export type MosaicGetUsersResponseLinksDto = {
  __typename?: "MosaicGetUsersResponseLinksDto";
  additionalResults: Maybe<Scalars["String"]>;
};

export type MosaicPostApplicationBodyDto = {
  disclosuresBundleId: Scalars["String"];
  externalId: Scalars["String"];
  language: Scalars["String"];
  mailingAddress: MosaicAddressDto;
  otherHouseholdIncome: Scalars["Float"];
  partnerIdentifier: Scalars["String"];
  primaryApplicant: MosaicApplicantDto;
  projectAddress: MosaicAddressDto;
  salesRepExternalIdentifier: Scalars["String"];
  salesRepIdentifier: Scalars["String"];
  secondaryApplicant?: InputMaybe<MosaicApplicantDto>;
};

export type MosaicPostApplicationResponseDto = {
  __typename?: "MosaicPostApplicationResponseDto";
  application: MosaicApplicationDto;
};

export type Mutation = {
  __typename?: "Mutation";
  activateDesign: Design;
  activateLoanProduct: LoanProduct;
  /** activate or deactivate a utility company */
  activateUtilityCompany: UtilityCompany;
  /** activate or deactivate a utility rate */
  activateUtilityRate: UtilityRate;
  addNoteDesignRequest: DesignRequest;
  claimDesignRequest: DesignRequest;
  claimNextDesignRequest: DesignRequest;
  completeClaimedDesignRequest: DesignRequest;
  completeClaimedDesignRequestAndClaimNext: DesignRequest;
  completeDesignRequest: DesignRequest;
  completeDesignRequestAndClaimNext: DesignRequest;
  createDesignRequest: DesignRequest;
  createProposalAudit: ProposalAudit;
  createServiceIntegration: ServiceIntegration;
  createSite: Site;
  /** created a new user */
  createUser: User;
  deactivateApiKey: ServiceIntegration;
  generateApiKey: ServiceIntegration;
  getTaxes: TaxjarTaxForOrderResponse;
  getUtilityBillUploadUrl: Scalars["String"];
  logout: Scalars["Boolean"];
  mosaicPostUser: MosaicGetUsersResponseDto;
  prioritizeDesignRequest: DesignRequest;
  /** soft remove the site from database matching provided id */
  removeSite: Maybe<Scalars["Boolean"]>;
  /** soft remove the user from database matching provided id */
  removeUser: Maybe<Scalars["Boolean"]>;
  sendCreditApplication: SendCreditApplicationResponse;
  sendLoanDocuments: ActiveLoan;
  syncEquipment: Scalars["Boolean"];
  syncLoanProducts: SyncLoanOfferResponse;
  updateDesign: Design;
  updateImagePosition: Imagery;
  updateLoanProduct: LoanProduct;
  updateProposal: Proposal;
  updateServiceIntegration: ServiceIntegration;
  updateSite: Site;
  updateStatusDesignComplete: ProposalStatus;
  updateStatusDesignFailed: ProposalStatus;
  updateStatusDesignQueued: ProposalStatus;
  updateStatusDesignRejected: ProposalStatus;
  updateStatusDesignUnderway: ProposalStatus;
  updateStatusProposalContractRequested: ProposalStatus;
  updateStatusProposalCreated: ProposalStatus;
  updateStatusProposalPublished: ProposalStatus;
  updateStatusSummaryConfirmed: ProposalStatus;
  /** update the given user with provided fields, returns a Not Found Error if the user does not exist */
  updateUser: User;
};

export type MutationActivateDesignArgs = {
  id: Scalars["ID"];
};

export type MutationActivateLoanProductArgs = {
  id: Scalars["ID"];
};

export type MutationActivateUtilityCompanyArgs = {
  utilityCompanyId: InputMaybe<Scalars["String"]>;
};

export type MutationActivateUtilityRateArgs = {
  utilityRateId: InputMaybe<Scalars["String"]>;
};

export type MutationAddNoteDesignRequestArgs = {
  id: Scalars["ID"];
  message: Scalars["String"];
};

export type MutationClaimDesignRequestArgs = {
  id: Scalars["ID"];
};

export type MutationCompleteDesignRequestArgs = {
  id: Scalars["ID"];
};

export type MutationCompleteDesignRequestAndClaimNextArgs = {
  id: Scalars["ID"];
};

export type MutationCreateDesignRequestArgs = {
  initialMessage: InputMaybe<Scalars["String"]>;
  proposalId: Scalars["ID"];
};

export type MutationCreateProposalAuditArgs = {
  proposalAudit: CreateProposalAuditInput;
};

export type MutationCreateServiceIntegrationArgs = {
  createServiceIntegrationInput: CreateServiceIntegrationInput;
};

export type MutationCreateSiteArgs = {
  createSiteInput: CreateSiteInput;
};

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type MutationDeactivateApiKeyArgs = {
  id: Scalars["ID"];
};

export type MutationGenerateApiKeyArgs = {
  id: Scalars["ID"];
};

export type MutationGetTaxesArgs = {
  input: TaxjarTaxForOrderParams;
};

export type MutationGetUtilityBillUploadUrlArgs = {
  getUtilityBillUploadUrlInput: GetUtilityBillUploadUrlInput;
};

export type MutationMosaicPostUserArgs = {
  input: MosaicCreateNewUserBodyDto;
};

export type MutationPrioritizeDesignRequestArgs = {
  id: Scalars["ID"];
  priority: Scalars["Float"];
};

export type MutationRemoveSiteArgs = {
  id: Scalars["ID"];
};

export type MutationRemoveUserArgs = {
  id: Scalars["ID"];
};

export type MutationSendCreditApplicationArgs = {
  input: SendCreditApplicationInput;
};

export type MutationSendLoanDocumentsArgs = {
  activeLoanId: Scalars["ID"];
};

export type MutationUpdateDesignArgs = {
  input: UpdateDesignInput;
};

export type MutationUpdateImagePositionArgs = {
  imageryId: Scalars["ID"];
  updateImageryPositionInput: UpdateImageryPositionInput;
};

export type MutationUpdateLoanProductArgs = {
  UpdateLoanProductInput: UpdateLoanProductInput;
};

export type MutationUpdateProposalArgs = {
  updateProposalInput: UpdateProposalInput;
};

export type MutationUpdateServiceIntegrationArgs = {
  updateServiceIntegrationInput: UpdateServiceIntegrationInput;
};

export type MutationUpdateSiteArgs = {
  updateSiteInput: UpdateSiteInput;
};

export type MutationUpdateStatusDesignCompleteArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusDesignFailedArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusDesignQueuedArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusDesignRejectedArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusDesignUnderwayArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusProposalContractRequestedArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusProposalCreatedArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateStatusProposalPublishedArgs = {
  publishProposalInput: PublishProposalInput;
};

export type MutationUpdateStatusSummaryConfirmedArgs = {
  data: CreateProposalStatusInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars["ID"];
  updateUserInput: UpdateUserInput;
};

export type NexusAddress = {
  city: Scalars["String"];
  country: Scalars["String"];
  id: Scalars["String"];
  state: Scalars["String"];
  street: Scalars["String"];
  zip: Scalars["String"];
};

/** Goodleap Phone Type Type */
export enum Phone_Type {
  HOME = "HOME",
  MOBILE = "MOBILE",
}

/** Inputs used to make the request to PvWatts API */
export type PvWatts_Inputs = {
  __typename?: "PVWatts_Inputs";
  /**
   * Array type.
   *   Option	Description
   *   - 0	Fixed - Open Rack
   *   - 1	Fixed - Roof Mounted
   *   - 2	1-Axis
   *   - 3	1-Axis Backtracking
   *   - 4	2-Axis
   */
  array_type: Scalars["String"];
  /** Azimuth angle (degrees). */
  azimuth: Scalars["String"];
  /** DC to AC ratio. */
  dc_ac_ratio: Scalars["String"];
  /** Inverter efficiency. */
  inv_eff: Scalars["String"];
  /** Latitude of the input location. (degrees) */
  lat: Scalars["String"];
  /** Longitude of the input location. (degrees) */
  lon: Scalars["String"];
  /**  System losses (percent). */
  losses: Scalars["String"];
  /**
   * Module type.
   *
   *   Option	Description
   *   - 0	Standard
   *   - 1	Premium
   *   - 2	Thin film
   */
  module_type: Scalars["String"];
  /** Nameplate capacity (kW). */
  system_capacity: Scalars["String"];
  /** Tilt angle (degrees) */
  tilt: Scalars["String"];
};

export type PaginationInput = {
  skip?: InputMaybe<Scalars["Float"]>;
  take?: InputMaybe<Scalars["Float"]>;
};

export type PendingLoan = {
  __typename?: "PendingLoan";
  applicationId: Scalars["String"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  proposalId: Scalars["String"];
  selectedLoanId: Scalars["String"];
  syncedAt: Maybe<Scalars["DateTime"]>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type Phone = {
  type: Phone_Type | `${Phone_Type}`;
  value: Scalars["String"];
};

export type PowurOsManufacturer = {
  __typename?: "PowurOsManufacturer";
  createdById: Maybe<Scalars["String"]>;
  createdDateTime: Maybe<Scalars["String"]>;
  deletedById: Maybe<Scalars["String"]>;
  deletedDateTime: Maybe<Scalars["String"]>;
  id: Maybe<Scalars["Float"]>;
  modifiedById: Maybe<Scalars["String"]>;
  modifiedDateTime: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
};

export type ProfileImg = {
  __typename?: "ProfileImg";
  bucket: Maybe<Scalars["String"]>;
  sizes: Maybe<ImageSizes>;
};

export type ProjectBodyResponse = {
  __typename?: "ProjectBodyResponse";
  amountDrawn: Scalars["Float"];
  amountRemaining: Scalars["Float"];
  applicants: Array<ApplicantBodyResponse>;
  approvedForPayments: Scalars["Boolean"];
  apr: Scalars["Float"];
  blockDraw: Scalars["Boolean"];
  drawAutoApproved: Scalars["Boolean"];
  drawCount: Scalars["Float"];
  drawExpired: Scalars["Boolean"];
  externalId: Scalars["String"];
  hashId: Scalars["String"];
  id: Scalars["String"];
  installCity: Scalars["String"];
  installStateName: Scalars["String"];
  installStreet: Scalars["String"];
  installZipCode: Scalars["Float"];
  installerEnglishOnly: Scalars["Boolean"];
  installerId: Maybe<Scalars["String"]>;
  installerName: Maybe<Scalars["String"]>;
  isACH: Scalars["Boolean"];
  isCreditAuthorized: Scalars["Boolean"];
  itcCutoff: Scalars["String"];
  language: Scalars["String"];
  lender: Scalars["String"];
  maxAvailable: Scalars["Float"];
  nonACHApr: Scalars["Float"];
  ownerEmail: Scalars["String"];
  ownerName: Scalars["String"];
  productType: Scalars["String"];
  projectCategory: Scalars["String"];
  projectStatus: Maybe<Scalars["String"]>;
  quotes: Array<QuoteBodyResponse>;
  requestedLoanAmount: Scalars["Float"];
  showTranslationServices: Scalars["Boolean"];
  slfProductMinLoanAmount: Scalars["Float"];
  stage: Scalars["String"];
  statusText: Scalars["String"];
  stips: Maybe<Array<StipsBodyResponse>>;
  systemDesigns: Array<SystemDesignBodyResponse>;
  term: Scalars["Float"];
};

export type PropertyKey = {
  __typename?: "PropertyKey";
  /** For properties of type CHOICE or LOOKUP, this contains the possible choices to choose from. */
  choices: Maybe<Array<Scalars["String"]>>;
  /** The data type of this property. Possible values are STRING, CHOICE, BOOLEAN, DATE, DECIMAL, INTEGER, FORMULA, LOOKUP (see Lookup API), or DEMAND. */
  dataType: Maybe<Scalars["String"]>;
  /** A user friendly detailed description of the purpose of this property. */
  description: Maybe<Scalars["String"]>;
  /** A string that can be used to display to users. */
  displayName: Maybe<Scalars["String"]>;
  /** The ID of the entity this property key belongs to. For example, for an LSE specific property, this will be the LSE ID. For general properties, this will be null. */
  entityId: Maybe<Scalars["Float"]>;
  /** The type of entity this property key belongs to. For example, for an LSE specific property this will be "LSE". For general properties this will be null. */
  entityType: Maybe<Scalars["String"]>;
  /** Second level of the categorization hierarchy, family groups keyNames together into logical areas, such as "billing", "generation", "load", "peakDemand", and "ratchetDemand". */
  family: Maybe<Scalars["String"]>;
  /** For properties that specify a formula, this is the actual formula used. */
  formulaDetail: Maybe<Scalars["String"]>;
  /** The unique name for this property. */
  keyName: Maybe<Scalars["String"]>;
  /** The top level of the categorization hierarchy, keyspace defines major groups of keyNames, such as "customer", "electricity", "market", “tariff”, and "solarPV". */
  keyspace: Maybe<Scalars["String"]>;
  /** For properties of type DEMAND, this specifies the size of the interval in minutes. */
  lookbackIntervalQuantity: Maybe<Scalars["Float"]>;
  /** For properties of type DEMAND, this specifies the duration of a single lookback period. */
  lookbackPeriod: Maybe<Scalars["String"]>;
  /** For properties of type DEMAND, this specifies the number of lookback periods. */
  lookbackQuantity: Maybe<Scalars["Float"]>;
  /** For properties of type DEMAND, this specifies the applicable seasonId . */
  lookbackSeasonId: Maybe<Scalars["Float"]>;
  /** For properties of type DEMAND, this specifies the applicable timeOfUseId. */
  lookbackTimeOfUseId: Maybe<Scalars["Float"]>;
  /** The unit that applies to this property. e.g. "kWh", "Inches", "HP", */
  quantityUnit: Maybe<Scalars["String"]>;
  /** Sub-property name for this property. */
  subKeyName: Maybe<Scalars["String"]>;
};

export type Proposal = {
  __typename?: "Proposal";
  activeLoan: Maybe<ActiveLoan>;
  /** Project adders */
  adders: Maybe<AddersObject>;
  addersId: Scalars["ID"];
  /** approximate annual energy use in kwh */
  annualEnergyUse: Maybe<Scalars["Float"]>;
  /** average monthly bill */
  averageMonthEnergyCost: Maybe<Scalars["Float"]>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  currentStatus: Scalars["String"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  designs: Array<Design>;
  downPayment: Maybe<Scalars["Float"]>;
  enterprise: Maybe<Enterprise>;
  enterpriseId: Maybe<Scalars["String"]>;
  genabilityEnergyProfileId: Scalars["String"];
  /** fixed genability rate */
  genabilityRate: Array<Scalars["Float"]>;
  /** Homeowner for whom the proposal is being prepared */
  homeowner: User;
  homeownerId: Scalars["ID"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  incentives: Maybe<Array<Incentive>>;
  margin: Scalars["Float"];
  mentor: Maybe<User>;
  mentorId: Maybe<Scalars["String"]>;
  /** historic energy cost in $ */
  monthlyEnergyCost: Array<Scalars["Float"]>;
  /** historic energy usage kWh */
  monthlyEnergyUse: Array<Scalars["Float"]>;
  newCustomerIncentive: Scalars["Boolean"];
  pendingLoans: Maybe<Array<PendingLoan>>;
  /** Post-solar-install utility rate for the proposal */
  postSolarUtilityRate: Maybe<UtilityRate>;
  postSolarUtilityRateId: Scalars["ID"];
  powurProjectId: Maybe<Scalars["Float"]>;
  preferredLanguage: Scalars["String"];
  proposalStatuses: Maybe<Array<ProposalStatus>>;
  quotes: Maybe<Array<QuoteObject>>;
  roofType: Maybe<Scalars["String"]>;
  salesTax: Scalars["Float"];
  selectedLoanProducts: Maybe<Array<LoanProduct>>;
  /** Consultant for the proposal, has limited edit access */
  seller: User;
  sellerId: Scalars["ID"];
  /** Site for which the proposal is being prepared */
  site: Site;
  siteId: Scalars["ID"];
  /** Short unique identifier for the proposal */
  slug: Scalars["String"];
  /** system type (roof mount, ground mount, or both) */
  systemType: Maybe<SystemType | `${SystemType}`>;
  totalCost: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  /** google cloud storage key for downloads */
  utilityBillFilename: Maybe<Scalars["String"]>;
  /** Status of utility bill upload */
  utilityBillUploadStatus: Maybe<UploadStatus | `${UploadStatus}`>;
  /** Utility rate plan for the proposal */
  utilityRate: Maybe<UtilityRate>;
  utilityRateEditedAt: Maybe<Scalars["DateTime"]>;
  /** utility rate escalation percentage */
  utilityRateEscalationPercentage: Scalars["Float"];
  utilityRateId: Scalars["ID"];
};

export type ProposalAudit = {
  __typename?: "ProposalAudit";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** audit event type */
  eventType: ProposalAuditEventType | `${ProposalAuditEventType}`;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** proposal that was modified */
  proposal: Proposal;
  proposalId: Scalars["ID"];
  /** the result of the update */
  result: Maybe<Scalars["Float"]>;
  /** individual search params */
  searchParams: Maybe<Array<Scalars["String"]>>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  /** who performed the update */
  updatedBy: User;
  updatedById: Scalars["ID"];
};

export enum ProposalAuditEventType {
  created = "created",
  max_fit_completed = "max_fit_completed",
  max_fit_requested = "max_fit_requested",
  published = "published",
  updated = "updated",
}

export type ProposalStatus = {
  __typename?: "ProposalStatus";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** Status message */
  message: Scalars["String"];
  /** Proposal ID */
  proposalId: Scalars["String"];
  /** Proposal status type */
  status: ProposalStatusType | `${ProposalStatusType}`;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  /** Proposal updated by */
  updatedBy: Scalars["String"];
};

export enum ProposalStatusType {
  contract_requested = "contract_requested",
  contract_sent = "contract_sent",
  contract_signed = "contract_signed",
  design_complete = "design_complete",
  design_failed = "design_failed",
  design_queued = "design_queued",
  design_rejected = "design_rejected",
  design_underway = "design_underway",
  proposal_created = "proposal_created",
  proposal_published = "proposal_published",
  summary_confirmed = "summary_confirmed",
}

export type ProposalsFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]>;
};

export type ProposalsInput = {
  filter?: InputMaybe<ProposalsFindManyWhereInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<ProposalsOrderByInput>;
};

export type ProposalsOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>;
};

export type PublishProposalInput = {
  message: Scalars["String"];
  proposalId: Scalars["String"];
};

export type Query = {
  __typename?: "Query";
  contract: Contract;
  contractsForProposal: Array<Contract>;
  design: Design;
  designHasSunroof: Scalars["Boolean"];
  designRequest: DesignRequest;
  designerDataByRequestId: DesignRequest;
  designs: Array<Design>;
  equipmentForSite: Array<Equipment>;
  estimate: Estimate;
  estimatesForDesign: Array<Estimate>;
  /** finds all loan products */
  findAllLoanProducts: Array<LoanProduct>;
  findDisclosuresForLoanProduct: GetDisclosuresByLoanProductIdResponse;
  findLoanProductById: LoanProduct;
  findLoanProductsForSite: Array<LoanProduct>;
  getActiveLoanStatus: Scalars["String"];
  getFileDownloadUrl: Scalars["String"];
  getGoodLeapDisclosures: GoodLeapGetDisclosuresResponseDto;
  getGoodleapLoanDetails: GoodleapLoanResponse;
  getInProgressDesign: Design;
  getProposalStatusEvents: Array<ProposalStatus>;
  getQueue: Array<DesignRequest>;
  getQuotesForProposal: Array<QuoteObject>;
  getSunlightDisclosures: SunlightGetDisclosuresResponse;
  getSunlightFrame: Scalars["String"];
  getSunlightProjectStatus: SunlightGetStatusResponse;
  getUtilityBillDownloadUrl: Scalars["String"];
  imageryAudits: Array<ImageryAudit>;
  /** get rates for account */
  likelyRatesForSite: Array<UtilityRate>;
  mosaicGetApplication: MosaicGetApplicationResponseDto;
  mosaicGetUsers: MosaicGetUsersResponseDto;
  mosaicListDisclosures: MosaicGetDisclosuresResponseDto;
  profile: User;
  proposal: Proposal;
  proposalAudit: ProposalAudit;
  proposalAudits: Array<ProposalAudit>;
  proposalStatuses: Array<ProposalStatus>;
  proposals: Array<Proposal>;
  proposalsCount: Scalars["Float"];
  /** performs case insensitive pattern matching search against provided fields */
  searchLoanProducts: Array<LoanProduct>;
  /** performs case insensitive pattern matching search against provided fields */
  searchUsers: Array<User>;
  serviceIntegration: ServiceIntegration;
  serviceIntegrations: Array<ServiceIntegration>;
  site: Site;
  sites: Array<Site>;
  /** finds user by id */
  user: User;
  /** finds all users */
  users: Array<User>;
  /** Search all utility companies */
  utilityCompanies: Array<UtilityCompany>;
  utilityCompaniesCount: Scalars["Float"];
  /** Find utility companies for a given site's zip code */
  utilityCompaniesForSite: Array<UtilityCompany>;
  /** Find all utility rates */
  utilityRates: Array<UtilityRate>;
  utilityRatesCount: Scalars["Float"];
  /** Find utility rates for a given site */
  utilityRatesForSite: Array<UtilityRate>;
  /** Fetch utility tariffs from Genability and insert into db */
  utilityTariffs: Scalars["String"];
  /** Find utility rates for a utility company */
  utilityTariffsForCompany: Array<UtilityRate>;
};

export type QueryContractArgs = {
  id: Scalars["String"];
};

export type QueryContractsForProposalArgs = {
  proposalId: Scalars["String"];
};

export type QueryDesignArgs = {
  id: Scalars["ID"];
};

export type QueryDesignHasSunroofArgs = {
  id: Scalars["ID"];
};

export type QueryDesignRequestArgs = {
  id: Scalars["ID"];
};

export type QueryDesignerDataByRequestIdArgs = {
  id: Scalars["ID"];
};

export type QueryDesignsArgs = {
  designsInput: InputMaybe<DesignsInput>;
};

export type QueryEquipmentForSiteArgs = {
  siteId: Scalars["ID"];
};

export type QueryEstimateArgs = {
  findEstimateInput: FindEstimateInput;
};

export type QueryEstimatesForDesignArgs = {
  designId: Scalars["ID"];
};

export type QueryFindAllLoanProductsArgs = {
  loanProductsInput: InputMaybe<LoanProductsInput>;
};

export type QueryFindDisclosuresForLoanProductArgs = {
  id: Scalars["ID"];
};

export type QueryFindLoanProductByIdArgs = {
  id: Scalars["ID"];
};

export type QueryFindLoanProductsForSiteArgs = {
  siteId: Scalars["ID"];
};

export type QueryGetActiveLoanStatusArgs = {
  id: Scalars["String"];
};

export type QueryGetFileDownloadUrlArgs = {
  bucketName: Scalars["String"];
  fileName: Scalars["String"];
};

export type QueryGetProposalStatusEventsArgs = {
  proposalId: Scalars["String"];
};

export type QueryGetQueueArgs = {
  take: Scalars["Float"];
};

export type QueryGetQuotesForProposalArgs = {
  id: Scalars["ID"];
};

export type QueryGetSunlightFrameArgs = {
  input: GetSunlightIframeUrlDto;
};

export type QueryGetSunlightProjectStatusArgs = {
  id: Scalars["String"];
};

export type QueryGetUtilityBillDownloadUrlArgs = {
  proposalId: Scalars["String"];
};

export type QueryLikelyRatesForSiteArgs = {
  siteId: Scalars["ID"];
};

export type QueryMosaicGetApplicationArgs = {
  input: Scalars["ID"];
};

export type QueryMosaicGetUsersArgs = {
  input: MosaicGetUsersBodyDto;
};

export type QueryMosaicListDisclosuresArgs = {
  input: MosaicGetDisclosuresBodyDto;
};

export type QueryProposalArgs = {
  findProposalInput: FindProposalInput;
};

export type QueryProposalAuditArgs = {
  id: Scalars["ID"];
};

export type QueryProposalsArgs = {
  proposalListInput: InputMaybe<ProposalsInput>;
};

export type QueryProposalsCountArgs = {
  proposalListInput: InputMaybe<ProposalsInput>;
};

export type QuerySearchLoanProductsArgs = {
  searchTerms: SearchLoanProductInput;
};

export type QuerySearchUsersArgs = {
  searchTerms: SearchUserInput;
};

export type QueryServiceIntegrationArgs = {
  id: Scalars["ID"];
};

export type QueryServiceIntegrationsArgs = {
  serviceIntegrationsInput: InputMaybe<ServiceIntegrationsInput>;
};

export type QuerySiteArgs = {
  id: Scalars["ID"];
};

export type QueryUserArgs = {
  id: Scalars["ID"];
};

export type QueryUsersArgs = {
  usersInput: InputMaybe<UsersInput>;
};

export type QueryUtilityCompaniesArgs = {
  utilityCompanyInput: InputMaybe<UtilityCompanyInput>;
};

export type QueryUtilityCompaniesCountArgs = {
  utilityCompanyInput: InputMaybe<UtilityCompanyInput>;
};

export type QueryUtilityCompaniesForSiteArgs = {
  siteId: Scalars["ID"];
};

export type QueryUtilityRatesArgs = {
  utilityRateInput: InputMaybe<UtilityRateInput>;
};

export type QueryUtilityRatesCountArgs = {
  utilityRateInput: InputMaybe<UtilityRateInput>;
};

export type QueryUtilityRatesForSiteArgs = {
  siteId: Scalars["ID"];
};

export type QueryUtilityTariffsForCompanyArgs = {
  lseId: Scalars["String"];
};

export type QuoteBodyResponse = {
  __typename?: "QuoteBodyResponse";
  apr: Scalars["Float"];
  createdDateTime: Scalars["String"];
  escalatedMonthlyPayment: Scalars["Float"];
  finalEscalatedMonthlyPayment: Scalars["Float"];
  finalMonthlyPayment: Scalars["Float"];
  id: Scalars["String"];
  includesBattery: Scalars["Boolean"];
  isACH: Scalars["Boolean"];
  isSyncing: Scalars["Boolean"];
  loanAmount: Scalars["Float"];
  monthlyPayment: Scalars["Float"];
  nonACHApr: Scalars["Float"];
  prePaymentPercentage: Scalars["Float"];
  productName: Scalars["String"];
  productType: Scalars["String"];
  quoteNumber: Scalars["String"];
  systemDesignId: Scalars["String"];
  term: Scalars["Float"];
};

export type QuoteObject = {
  __typename?: "QuoteObject";
  alternateMonthlyPayment: Maybe<Scalars["Float"]>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  finalEscalatedMonthlyPayment: Maybe<Scalars["Float"]>;
  finalMonthlyPayment: Maybe<Scalars["Float"]>;
  goodleapJson: Maybe<GoodleapPaymentsResponse>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  loanAmount: Maybe<Scalars["Float"]>;
  loanProductId: Scalars["String"];
  monthlyAdjustedPayment: Scalars["Float"];
  monthlyInitialPayment: Scalars["Float"];
  monthlyPayments: Maybe<Array<Scalars["JSON"]>>;
  paydownPercentage: Maybe<Scalars["Float"]>;
  paymentFactors: Maybe<Scalars["JSON"]>;
  proposalId: Scalars["String"];
  totalProjectCost: Maybe<Scalars["Float"]>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type QuotesSubmitCreditResponse = {
  __typename?: "QuotesSubmitCreditResponse";
  approvingCredits: Array<Scalars["String"]>;
  apr: Scalars["Float"];
  createdDateTime: Scalars["String"];
  escalatedMonthlyPayment: Scalars["Float"];
  finalEscalatedMonthlyPayment: Scalars["Float"];
  finalMonthlyPayment: Scalars["Float"];
  id: Scalars["String"];
  includesBattery: Scalars["Boolean"];
  isACH: Scalars["Boolean"];
  isSyncing: Scalars["Boolean"];
  loanAmount: Scalars["Float"];
  monthlyPayment: Scalars["Float"];
  nonACHApr: Scalars["String"];
  prePaymentPercentage: Scalars["Float"];
  productName: Scalars["String"];
  productType: Scalars["String"];
  quoteNumber: Scalars["String"];
  systemDesignId: Scalars["String"];
  term: Scalars["Float"];
};

export type RateBand = {
  __typename?: "RateBand";
  rateAmount: Scalars["Float"];
};

export type Region = {
  __typename?: "Region";
  adderRegionAdders: Maybe<Array<AdderRegionAdder>>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  getPostCodes: Array<Scalars["String"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  name: Scalars["String"];
  postalCodes: Maybe<Scalars["String"]>;
  powurOsId: Scalars["Float"];
  region: Scalars["JSON"];
  regionCode: Scalars["String"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type RelatedEquipmentObject = {
  __typename?: "RelatedEquipmentObject";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  designId: Scalars["String"];
  equipment: Equipment;
  equipmentId: Scalars["String"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  quantity: Scalars["Float"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

/** Goodleap Spoken Language Type */
export enum Spoken_Language {
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
}

export type Savings = {
  __typename?: "Savings";
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  designId: Scalars["String"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  inputs: CreateSavingsAnalysisDto;
  outputs: SavingsAnalysis;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type SavingsAnalysis = {
  __typename?: "SavingsAnalysis";
  currency: Scalars["String"];
  dataStatus: Scalars["Float"];
  designId: Maybe<Scalars["String"]>;
  scenarios: Array<AnalysisScenario>;
  series: Array<AnalysisSeries>;
  seriesCosts: Maybe<Array<SeriesCost>>;
  seriesData: Array<SeriesData>;
  summary: AnalysisSummary;
};

export type SavingsPropertyInputs = {
  __typename?: "SavingsPropertyInputs";
  dataValue: Scalars["String"];
  keyName: Scalars["String"];
  scenarios: Scalars["String"];
};

export type SavingsRateInputs = {
  __typename?: "SavingsRateInputs";
  chargeType: Scalars["String"];
  rateBands: Array<RateBand>;
  scenarios: Scalars["String"];
};

export type SearchLoanProductInput = {
  /** string for the provider */
  provider?: InputMaybe<Scalars["String"]>;
};

export type SearchUserInput = {
  email?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  roles?: InputMaybe<Array<UserRole | `${UserRole}`>>;
};

export type SendCreditApplicationInput = {
  goodLeapRequest?: InputMaybe<GoodLeapCreateLoanRequestDto>;
  mosaicRequest?: InputMaybe<MosaicPostApplicationBodyDto>;
  provider: LoanProvider | `${LoanProvider}`;
  selectedLoanProductId: Scalars["String"];
  sunlightRequest?: InputMaybe<SunlightSubmitCreditBodyDto>;
};

export type SendCreditApplicationResponse =
  | GoodLeapCreateLoanResponseDto
  | MosaicPostApplicationResponseDto
  | SunlightSubmitCreditResponseDto;

export type SeriesCost = {
  __typename?: "SeriesCost";
  accuracy: Maybe<Scalars["Float"]>;
  calculationId: Maybe<Scalars["Float"]>;
  currency: Maybe<Scalars["String"]>;
  fromDateTime: Maybe<Scalars["String"]>;
  items: Array<SeriesCostItem>;
  masterTariffId: Maybe<Scalars["Float"]>;
  summary: CostSummary;
  tariffName: Maybe<Scalars["String"]>;
  toDateTime: Maybe<Scalars["String"]>;
  totalCost: Maybe<Scalars["Float"]>;
};

export type SeriesCostItem = {
  __typename?: "SeriesCostItem";
  chargeClass: Maybe<Scalars["String"]>;
  chargeType: Maybe<Scalars["String"]>;
  cost: Maybe<Scalars["Float"]>;
  demandInterval: Maybe<Scalars["String"]>;
  duration: Maybe<Scalars["String"]>;
  formula: Maybe<Scalars["String"]>;
  fromDateTime: Maybe<Scalars["String"]>;
  itemQuantity: Maybe<Scalars["Float"]>;
  period: Maybe<Scalars["String"]>;
  quantityKey: Maybe<Scalars["String"]>;
  quantityKeyDescription: Maybe<Scalars["String"]>;
  rateAmount: Maybe<Scalars["Float"]>;
  rateGroupName: Maybe<Scalars["String"]>;
  rateName: Maybe<Scalars["String"]>;
  rateProration: Maybe<Scalars["Float"]>;
  rateSequenceNumber: Maybe<Scalars["Float"]>;
  rateType: Maybe<Scalars["String"]>;
  seasonId: Maybe<Scalars["Float"]>;
  seasonName: Maybe<Scalars["String"]>;
  tariffId: Maybe<Scalars["Float"]>;
  tariffRateBandId: Maybe<Scalars["Float"]>;
  tariffRateId: Maybe<Scalars["Float"]>;
  tierLowerLimit: Maybe<Scalars["Float"]>;
  tierUpperLimit: Maybe<Scalars["Float"]>;
  toDateTime: Maybe<Scalars["String"]>;
  touId: Maybe<Scalars["Float"]>;
  touName: Maybe<Scalars["String"]>;
  transactionType: Maybe<Scalars["String"]>;
};

export type SeriesData = {
  __typename?: "SeriesData";
  cost: Scalars["Float"];
  fromDateTime: Scalars["String"];
  qty: Scalars["Float"];
  rate: Scalars["Float"];
  seriesId: Scalars["Float"];
  toDateTime: Scalars["String"];
};

export type ServiceIntegration = {
  __typename?: "ServiceIntegration";
  apiKeys: Array<ApiKey>;
  contactEmail: Scalars["String"];
  contactName: Scalars["String"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  name: Scalars["String"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type ServiceIntegrationFilterInput = {
  search?: InputMaybe<Scalars["String"]>;
};

export type ServiceIntegrationSortInput = {
  contactEmail?: InputMaybe<SortOrder | `${SortOrder}`>;
  contactName?: InputMaybe<SortOrder | `${SortOrder}`>;
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>;
  name?: InputMaybe<SortOrder | `${SortOrder}`>;
};

export type ServiceIntegrationsInput = {
  filter?: InputMaybe<ServiceIntegrationFilterInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<ServiceIntegrationSortInput>;
};

export type Site = {
  __typename?: "Site";
  /** Normalized address (123 S Main St. Anytown USA, 00000) */
  address: Scalars["String"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** Account ID from Genability */
  genabilityAccountId: Maybe<Scalars["String"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** Imagery for this site */
  imagery: Array<ImageryResult>;
  /** Site Latitude (-90.0 - 90.0 */
  latitude: Scalars["Float"];
  /** Site locality */
  locality: Scalars["String"];
  /** Site Longitude (-180.0 - 180.0 */
  longitude: Scalars["Float"];
  /** Site zip code */
  postalCode: Scalars["String"];
  /** Site zip code suffix */
  postalCodeSuffix: Scalars["String"];
  /** Site state */
  state: StateCode | `${StateCode}`;
  /** street address */
  street: Scalars["String"];
  /** Street View Latitude (-90.0 - 90.0 */
  streetViewLatitude: Maybe<Scalars["Float"]>;
  /** Street View Longitude (-180.0 - 180.0 */
  streetViewLongitude: Maybe<Scalars["Float"]>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

/** Information about the SSC library. */
export type SscInfo = {
  __typename?: "SscInfo";
  /** Build Identifier */
  build: Scalars["String"];
  /** Version number */
  version: Scalars["Float"];
};

export enum StateCode {
  AK = "AK",
  AL = "AL",
  AR = "AR",
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  DE = "DE",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  IA = "IA",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  MA = "MA",
  MD = "MD",
  ME = "ME",
  MI = "MI",
  MN = "MN",
  MO = "MO",
  MS = "MS",
  MT = "MT",
  NC = "NC",
  ND = "ND",
  NE = "NE",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NV = "NV",
  NY = "NY",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  PR = "PR",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VA = "VA",
  VT = "VT",
  WA = "WA",
  WI = "WI",
  WV = "WV",
  WY = "WY",
}

/** Information about the climate data used in the simulation. */
export type StationInfo = {
  __typename?: "StationInfo";
  /** City where climate station is located. */
  city: Scalars["String"];
  /** Distance between the input location and the climate station. (meters) */
  distance: Scalars["Float"];
  /** Elevation of the climate station. (meters) */
  elev: Scalars["Float"];
  /** Latitude of the climate station. */
  lat: Scalars["Float"];
  /** ID of the climate station. */
  location: Scalars["String"];
  /** Longitude of the climate station. */
  lon: Scalars["Float"];
  /** Solar resource filename. */
  solar_resource_file: Scalars["String"];
  /** State where climate station is located. */
  state: Scalars["String"];
  /** Timezone offset from GMT. */
  tz: Scalars["Float"];
};

export type StipsBodyResponse = {
  __typename?: "StipsBodyResponse";
  description: Scalars["String"];
  id: Scalars["String"];
  installerOnlyEmail: Scalars["Boolean"];
  isStipSuppressed: Scalars["Boolean"];
  name: Scalars["String"];
  status: Scalars["String"];
};

export type StipsSubmitCreditResponse = {
  __typename?: "StipsSubmitCreditResponse";
  description: Scalars["String"];
  displayFolderText: Scalars["String"];
  folderName: Scalars["String"];
  id: Scalars["String"];
  installerOnlyEmail: Scalars["Boolean"];
  isStipSuppressed: Scalars["Boolean"];
  name: Scalars["String"];
  status: Scalars["String"];
};

export type Stipulation = {
  __typename?: "Stipulation";
  appliesTo: Scalars["String"];
  attachments: Array<Attachment>;
  createdAt: Scalars["String"];
  deferred: Scalars["Boolean"];
  description: Scalars["String"];
  documentsToClear: Array<Document>;
  domain: Scalars["String"];
  id: Scalars["String"];
  name: Scalars["String"];
  reasonCodes: Array<Scalars["String"]>;
  status: Scalars["String"];
  type: Scalars["String"];
  updatedAt: Scalars["String"];
  updatedBy: Scalars["String"];
};

export type SubjectProperty = {
  address: Address;
  mortgageTotalBalances?: InputMaybe<CurrencyInput>;
  mortgageTotalPayments?: InputMaybe<CurrencyInput>;
};

export type SubmitCreditBody = {
  applicants: Array<ApplicantSubmitCreditBody>;
  id?: InputMaybe<Scalars["String"]>;
  isCreditAuthorized?: InputMaybe<Scalars["Boolean"]>;
};

export type SubmitCreditResponse = {
  __typename?: "SubmitCreditResponse";
  amountDrawn: Scalars["Float"];
  amountRemaining: Scalars["Float"];
  applicants: Array<ApplicantSubmitCreditResponse>;
  approvedForPayments: Scalars["Boolean"];
  apr: Scalars["Float"];
  blockDraw: Scalars["Boolean"];
  credits: Array<CreditsSubmitCreditResponse>;
  drawAutoApproved: Scalars["Boolean"];
  drawCount: Scalars["Float"];
  drawExpired: Scalars["Boolean"];
  externalId: Scalars["String"];
  hashId: Scalars["String"];
  id: Scalars["String"];
  installCity: Scalars["String"];
  installStateName: Scalars["String"];
  installStreet: Scalars["String"];
  installZipCode: Scalars["String"];
  installerEnglishOnly: Scalars["Boolean"];
  installerName: Scalars["String"];
  isACH: Scalars["Boolean"];
  isCreditAuthorized: Scalars["Boolean"];
  itcCutoff: Scalars["String"];
  language: Scalars["String"];
  lender: Scalars["String"];
  maxAvailable: Scalars["Float"];
  nonACHApr: Scalars["Float"];
  ownerEmail: Scalars["String"];
  ownerName: Scalars["String"];
  productType: Scalars["String"];
  projectCategory: Scalars["String"];
  projectStatus: Scalars["String"];
  quotes: Array<QuotesSubmitCreditResponse>;
  requestedLoanAmount: Scalars["Float"];
  showTranslationServices: Scalars["Boolean"];
  slfProductMinLoanAmount: Scalars["Float"];
  stage: Scalars["String"];
  statusText: Scalars["String"];
  stips: Array<StipsSubmitCreditResponse>;
  systemDesigns: Array<SystemsDesignSubmitCreditResponse>;
  term: Scalars["Float"];
};

export type SubmittingUser = {
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
};

export type SunlightDisclosure = {
  __typename?: "SunlightDisclosure";
  disclosureText: Scalars["String"];
  isHome: Scalars["Boolean"];
  isSolar: Scalars["Boolean"];
  spanishDisclosureText: Scalars["String"];
  type: Scalars["String"];
};

export type SunlightGetDisclosuresResponse = {
  __typename?: "SunlightGetDisclosuresResponse";
  projects: Array<SunlightProjectsArray>;
  returnCode: Scalars["String"];
};

export type SunlightGetStatusResponse = {
  __typename?: "SunlightGetStatusResponse";
  projects: Array<ProjectBodyResponse>;
  returnCode: Scalars["String"];
};

export type SunlightProjectsArray = {
  __typename?: "SunlightProjectsArray";
  disclosures: Array<SunlightDisclosure>;
};

export type SunlightSubmitCreditBodyDto = {
  projects: Array<SubmitCreditBody>;
};

export type SunlightSubmitCreditResponseDto = {
  __typename?: "SunlightSubmitCreditResponseDto";
  projects: Array<SubmitCreditResponse>;
};

export type SyncLoanOfferResponse = {
  __typename?: "SyncLoanOfferResponse";
  created: Scalars["Float"];
  fetched: Scalars["Float"];
  unchanged: Scalars["Float"];
  updated: Scalars["Float"];
};

export type SystemDesignBodyResponse = {
  __typename?: "SystemDesignBodyResponse";
  estAnnualProductionkwh: Scalars["Float"];
  id: Scalars["String"];
  inverterCount: Scalars["Float"];
  inverterMake: Scalars["String"];
  inverterMakeName: Scalars["String"];
  inverterModel: Scalars["String"];
  moduleCount: Scalars["Float"];
  moduleMake: Scalars["String"];
  moduleMakeName: Scalars["String"];
  moduleModel: Scalars["String"];
  projectType: Scalars["String"];
  systemSize: Scalars["Float"];
};

export enum SystemType {
  both = "both",
  ground_mount = "ground_mount",
  roof_mount = "roof_mount",
}

export type SystemsDesignSubmitCreditResponse = {
  __typename?: "SystemsDesignSubmitCreditResponse";
  estAnnualProductionkwh: Scalars["Float"];
  id: Scalars["String"];
  inverterCount: Scalars["Float"];
  inverterMake: Scalars["String"];
  inverterMakeName: Scalars["String"];
  inverterModel: Scalars["String"];
  moduleCount: Scalars["Float"];
  moduleMake: Scalars["String"];
  moduleMakeName: Scalars["String"];
  moduleModel: Scalars["String"];
  projectType: Scalars["String"];
  systemSize: Scalars["Float"];
};

export type TaxLineItem = {
  discount: Scalars["Float"];
  id: Scalars["String"];
  product_tax_code: Scalars["String"];
  quantity: Scalars["Float"];
  unit_price: Scalars["Float"];
};

export type TaxStatus = {
  __typename?: "TaxStatus";
  id: Maybe<Scalars["Float"]>;
  name: Maybe<Scalars["String"]>;
};

export type TaxjarJurisdictions = {
  __typename?: "TaxjarJurisdictions";
  city: Scalars["String"];
  country: Scalars["String"];
  county: Scalars["String"];
  state: Scalars["String"];
};

export type TaxjarTaxField = {
  __typename?: "TaxjarTaxField";
  amount_to_collect: Scalars["Float"];
  breakdown: Breakdown;
  exemption_type: Scalars["String"];
  freight_taxable: Scalars["Boolean"];
  has_nexus: Scalars["Boolean"];
  jurisdictions: TaxjarJurisdictions;
  order_total_amount: Scalars["Float"];
  rate: Scalars["Float"];
  shipping: Scalars["Float"];
  tax_source: Scalars["String"];
  taxable_amount: Scalars["Float"];
};

export type TaxjarTaxForOrderParams = {
  amount?: InputMaybe<Scalars["Float"]>;
  customer_id?: InputMaybe<Scalars["String"]>;
  exemption_type?: InputMaybe<Scalars["String"]>;
  from_city?: InputMaybe<Scalars["String"]>;
  from_country?: InputMaybe<Scalars["String"]>;
  from_state?: InputMaybe<Scalars["String"]>;
  from_street?: InputMaybe<Scalars["String"]>;
  from_zip?: InputMaybe<Scalars["String"]>;
  line_items?: InputMaybe<Array<TaxLineItem>>;
  nexus_addresses?: InputMaybe<Array<NexusAddress>>;
  shipping: Scalars["Float"];
  to_city?: InputMaybe<Scalars["String"]>;
  to_country?: InputMaybe<Scalars["String"]>;
  to_state?: InputMaybe<Scalars["String"]>;
  to_street?: InputMaybe<Scalars["String"]>;
  to_zip?: InputMaybe<Scalars["String"]>;
};

export type TaxjarTaxForOrderResponse = {
  __typename?: "TaxjarTaxForOrderResponse";
  tax: TaxjarTaxField;
};

export type UpdateAdderInput = {
  customPrice?: InputMaybe<Scalars["Float"]>;
  customQuantity?: InputMaybe<Scalars["Float"]>;
  id: Scalars["String"];
  selected?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateAddersInput = {
  id: Scalars["String"];
  items: Array<UpdateAdderInput>;
};

export type UpdateDesignInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]>;
  batteryCompatibility?: InputMaybe<Scalars["Boolean"]>;
  brochurePositionX?: InputMaybe<Scalars["Float"]>;
  brochurePositionY?: InputMaybe<Scalars["Float"]>;
  brochureZoom?: InputMaybe<Scalars["Float"]>;
  completedAt?: InputMaybe<Scalars["DateTime"]>;
  displayImageryProvider?: InputMaybe<Scalars["String"]>;
  edges?: InputMaybe<Scalars["JSON"]>;
  energyBackupId?: InputMaybe<Scalars["String"]>;
  energyEfficiencyKitRebate?: InputMaybe<Scalars["Boolean"]>;
  energyEfficiencyKitRebateAmount?: InputMaybe<Scalars["Float"]>;
  evCharger?: InputMaybe<Scalars["Boolean"]>;
  evOutlet?: InputMaybe<Scalars["Boolean"]>;
  homeownerJwt?: InputMaybe<Scalars["String"]>;
  homeownerRebate?: InputMaybe<Scalars["Boolean"]>;
  homeownerRebateAmount?: InputMaybe<Scalars["Float"]>;
  id: Scalars["ID"];
  installAreas?: InputMaybe<Scalars["JSON"]>;
  installAreasToPanels?: InputMaybe<Scalars["JSON"]>;
  inverterId?: InputMaybe<Scalars["String"]>;
  inverterManufacturer?: InputMaybe<Scalars["String"]>;
  jwtExpiresAt?: InputMaybe<Scalars["DateTime"]>;
  nodes?: InputMaybe<Scalars["JSON"]>;
  obstructions?: InputMaybe<Scalars["JSON"]>;
  panels?: InputMaybe<Scalars["JSON"]>;
  phase?: InputMaybe<Scalars["String"]>;
  powurCareThirtyYearWarranty?: InputMaybe<Scalars["Boolean"]>;
  roofWorkRebate?: InputMaybe<Scalars["Boolean"]>;
  roofWorkRebateAmount?: InputMaybe<Scalars["Float"]>;
  secondaryInverterId?: InputMaybe<Scalars["String"]>;
  setbacks?: InputMaybe<Scalars["JSON"]>;
  shadingAreas?: InputMaybe<Scalars["JSON"]>;
  solarEdgeTwentyFiveYearWarranty?: InputMaybe<Scalars["Boolean"]>;
  solarEdgeTwentyFiveYearWarrantyPrice?: InputMaybe<Scalars["Float"]>;
  solarEdgeTwentyYearWarranty?: InputMaybe<Scalars["Boolean"]>;
  solarEdgeTwentyYearWarrantyPrice?: InputMaybe<Scalars["Float"]>;
  solarModuleId?: InputMaybe<Scalars["String"]>;
  tool?: InputMaybe<Scalars["String"]>;
  treeTrimmingRebate?: InputMaybe<Scalars["Boolean"]>;
  treeTrimmingRebateAmount?: InputMaybe<Scalars["Float"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type UpdateImageryPositionInput = {
  positionedX?: InputMaybe<Scalars["Float"]>;
  positionedY?: InputMaybe<Scalars["Float"]>;
  positionedZoom?: InputMaybe<Scalars["Float"]>;
};

export type UpdateIncentivesInput = {
  applyToLoan: Scalars["Boolean"];
  incentiveId: Scalars["Float"];
  showOnBrochure: Scalars["Boolean"];
};

export type UpdateLoanProductInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]>;
  id: Scalars["ID"];
  maximumLoanAmount?: InputMaybe<Scalars["Float"]>;
  minimumCreditScore?: InputMaybe<Scalars["Float"]>;
  minimumLoanAmount?: InputMaybe<Scalars["Float"]>;
  providerFee?: InputMaybe<Scalars["Float"]>;
  providerName?: InputMaybe<Scalars["String"]>;
  statesActive?: InputMaybe<Array<Scalars["String"]>>;
};

export type UpdateProposalInput = {
  /** Adders */
  adders?: InputMaybe<UpdateAddersInput>;
  annualEnergyUse?: InputMaybe<Scalars["Float"]>;
  /** Down Payment */
  downPayment?: InputMaybe<Scalars["Float"]>;
  genabilityRate?: InputMaybe<Array<Scalars["Float"]>>;
  id: Scalars["ID"];
  incentiveStatuses?: InputMaybe<Array<UpdateIncentivesInput>>;
  /** Margin (priced in $ per watt) */
  margin?: InputMaybe<Scalars["Float"]>;
  /** Selected mentor ID */
  mentorId?: InputMaybe<Scalars["String"]>;
  monthlyEnergyCost?: InputMaybe<Array<Scalars["Float"]>>;
  monthlyEnergyUse?: InputMaybe<Array<Scalars["Float"]>>;
  newCustomerIncentive?: InputMaybe<Scalars["Boolean"]>;
  newCustomerIncentiveMonths?: InputMaybe<Scalars["Float"]>;
  /** Post-solar-install utility rate id */
  postSolarInstallUtilityRateId?: InputMaybe<Scalars["String"]>;
  preferredLanguage?: InputMaybe<Scalars["String"]>;
  salesTax?: InputMaybe<Scalars["Float"]>;
  /** Selected loan product Ids */
  selectedLoanProductIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Consultant powur id */
  sellerId?: InputMaybe<Scalars["ID"]>;
  /** system type (roof mount, ground mount, or both) */
  systemType?: InputMaybe<SystemType | `${SystemType}`>;
  utilityBillFilename?: InputMaybe<Scalars["String"]>;
  /** Utility rate escalation percentage */
  utilityRateEscalationPercentage?: InputMaybe<Scalars["Float"]>;
  /** Utility rate id */
  utilityRateId?: InputMaybe<Scalars["String"]>;
};

export type UpdateServiceIntegrationInput = {
  contactEmail?: InputMaybe<Scalars["String"]>;
  contactName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
};

export type UpdateSiteInput = {
  /** Address of the site */
  address?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Latitude of the site */
  latitude?: InputMaybe<Scalars["Float"]>;
  /** Longitude of the site */
  longitude?: InputMaybe<Scalars["Float"]>;
  /** street view latitude of the site */
  streetViewLatitude?: InputMaybe<Scalars["Float"]>;
  /** Street view longitude of the site */
  streetViewLongitude?: InputMaybe<Scalars["Float"]>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id: Scalars["String"];
  lastName?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  roles?: InputMaybe<Array<UserRole | `${UserRole}`>>;
};

export enum UploadStatus {
  failure = "failure",
  none = "none",
  pending = "pending",
  success = "success",
}

export type User = {
  __typename?: "User";
  /** user bio */
  bio: Maybe<Scalars["String"]>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** user email */
  email: Scalars["String"];
  /** user first name */
  firstName: Scalars["String"];
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** user last name */
  lastName: Scalars["String"];
  /** user phone number */
  phone: Maybe<Scalars["String"]>;
  /** powur.com user id */
  powurUserId: Maybe<Scalars["Float"]>;
  /** user profile image url */
  profileImage: Maybe<ProfileImg>;
  /** user role for determining application permissions */
  roles: Array<UserRole | `${UserRole}`>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
};

export type UserFindManyWhereInput = {
  role?: InputMaybe<UserRole | `${UserRole}`>;
  search?: InputMaybe<Scalars["String"]>;
};

export enum UserRole {
  active_subscribers = "active_subscribers",
  admin = "admin",
  ambassador = "ambassador",
  api_key_admin = "api_key_admin",
  careers_administrator = "careers_administrator",
  commission_specialist = "commission_specialist",
  comped_subscribers = "comped_subscribers",
  consultants = "consultants",
  designer_user = "designer_user",
  energy = "energy",
  enterprise_comped = "enterprise_comped",
  enterprise_consultant = "enterprise_consultant",
  enterprise_manager = "enterprise_manager",
  enterprise_owner = "enterprise_owner",
  enterprise_owner_pro = "enterprise_owner_pro",
  enterprise_super_admin = "enterprise_super_admin",
  enterprise_support = "enterprise_support",
  equipment_admin = "equipment_admin",
  finance = "finance",
  financing_admin = "financing_admin",
  former_ambassador = "former_ambassador",
  guest = "guest",
  homeowner = "homeowner",
  installer = "installer",
  inv = "inv",
  lead_generator = "lead_generator",
  licenses_administrator = "licenses_administrator",
  marketing_staff = "marketing_staff",
  mentorship_assignment = "mentorship_assignment",
  ops_support = "ops_support",
  opsmanager = "opsmanager",
  platform_admins = "platform_admins",
  platform_communications = "platform_communications",
  proposal_admin = "proposal_admin",
  proposal_creation = "proposal_creation",
  sales_org = "sales_org",
  sales_pro = "sales_pro",
  sales_support = "sales_support",
  service_bureau_admin = "service_bureau_admin",
  service_bureau_user = "service_bureau_user",
  serviceareaupdater = "serviceareaupdater",
  user_admin = "user_admin",
  vision_admin = "vision_admin",
  vision_api_key_admin = "vision_api_key_admin",
  vision_designer_user = "vision_designer_user",
  vision_developer = "vision_developer",
  vision_equipment_admin = "vision_equipment_admin",
  vision_financing_admin = "vision_financing_admin",
  vision_proposal_admin = "vision_proposal_admin",
  vision_service_bureau_admin = "vision_service_bureau_admin",
  vision_service_bureau_user = "vision_service_bureau_user",
  vision_user_admin = "vision_user_admin",
}

export type UsersInput = {
  filter?: InputMaybe<UserFindManyWhereInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UsersOrderByInput>;
};

export type UsersOrderByInput = {
  email?: InputMaybe<SortOrder | `${SortOrder}`>;
  firstName?: InputMaybe<SortOrder | `${SortOrder}`>;
  lastName?: InputMaybe<SortOrder | `${SortOrder}`>;
};

export type UtilityCompany = {
  __typename?: "UtilityCompany";
  /** Activated date */
  activatedAt: Maybe<Scalars["DateTime"]>;
  /** Details about how the LSE represents billing periods. See https://developer.genability.com/api-reference/tariff-api/load-serving-entity/ for more details */
  billingPeriodRepresentation: Maybe<Scalars["JSON"]>;
  /** Short code (an alternate key). For US companies this is the EIA ID */
  code: Maybe<Scalars["String"]>;
  /** Commercial customer count */
  commercialCustomers: Maybe<Scalars["Float"]>;
  /** Annual commercial revenue in thousands of local currency (e.g. USD) */
  commercialRevenues: Maybe<Scalars["Float"]>;
  /** Annual commercial sales in MWh */
  commercialSales: Maybe<Scalars["Float"]>;
  /** Service types offered to commercial customers. Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  commercialServiceTypes: Maybe<Scalars["String"]>;
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** 	Industrial customer count */
  industrialCustomers: Maybe<Scalars["Float"]>;
  /** Annual industrial revenue in thousands of local currency (e.g. USD) */
  industrialRevenues: Maybe<Scalars["Float"]>;
  /** Annual industrial sales in MWh */
  industrialSales: Maybe<Scalars["Float"]>;
  /** Service types offered to industrial customers. Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  industrialServiceTypes: Maybe<Scalars["String"]>;
  /** Shorthand code for the company (PGE for Pacific Gas & Electric) */
  lseCode: Scalars["String"];
  /** Unique Genability ID (primary key) for each LSE */
  lseId: Scalars["Float"];
  /** Published name of the company */
  name: Scalars["String"];
  /** Utility classification based on the type of service they offer */
  offeringType: Scalars["String"];
  /** Ownership structure */
  ownership: Scalars["String"];
  /** Residential customer count */
  residentialCustomers: Maybe<Scalars["Float"]>;
  /** Annual residential revenue in thousands of local currency (e.g. USD) */
  residentialRevenues: Maybe<Scalars["Float"]>;
  /** Annual residential sales in MWh */
  residentialSales: Maybe<Scalars["Float"]>;
  /** Service types offered to residential customers. Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  residentialServiceTypes: Maybe<Scalars["String"]>;
  /** Service types offered to any customer */
  serviceTypes: Maybe<Scalars["String"]>;
  /** Total customer count */
  totalCustomers: Maybe<Scalars["Float"]>;
  /** Annual total revenue in thousands of local currency (e.g. USD) */
  totalRevenues: Maybe<Scalars["Float"]>;
  /** Annual total sales in MWh */
  totalSales: Maybe<Scalars["Float"]>;
  /** Transportation customer count */
  transportationCustomers: Maybe<Scalars["Float"]>;
  /** Annual transportation revenue in thousands of local currency (e.g. USD) */
  transportationRevenues: Maybe<Scalars["Float"]>;
  /** Annual transportation sales in MWh */
  transportationSales: Maybe<Scalars["Float"]>;
  /** Service types offered to transportation customers (such as municipal bus services, regional mass transit etc). Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  transportationServiceTypes: Maybe<Scalars["String"]>;
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  /** Utility Rates associated with this Utility Company */
  utilityRates: Maybe<Array<UtilityRate>>;
  /** The URL to the home page of the LSE website */
  websiteHome: Scalars["String"];
};

export type UtilityCompanyFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]>;
};

export type UtilityCompanyInput = {
  filter?: InputMaybe<UtilityCompanyFindManyWhereInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UtilityCompanyOrderByInput>;
};

export type UtilityCompanyOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>;
};

export type UtilityRate = {
  __typename?: "UtilityRate";
  /** Activated date */
  activatedAt: Maybe<Scalars["DateTime"]>;
  /** Genability billing period */
  billingPeriod: Scalars["String"];
  /** resource creation date */
  createdAt: Scalars["DateTime"];
  /** Genability currency */
  currency: Scalars["String"];
  /** Genability customer class */
  customerClass: Maybe<Scalars["String"]>;
  /** Genability customer likelihood */
  customerLikelihood: Maybe<Scalars["Float"]>;
  /** resource deletion date */
  deletedAt: Maybe<Scalars["DateTime"]>;
  /** Genability end date */
  endDate: Maybe<Scalars["String"]>;
  /** version 4(random) UUID */
  id: Scalars["ID"];
  /** active state per genability */
  isActive: Scalars["Boolean"];
  /** Genability lse (Utility Company) id */
  lseId: Scalars["String"];
  /** Genability lse (Utility Company) name */
  lseName: Scalars["String"];
  /** Genability master tariff (Rate) id */
  masterTariffId: Scalars["String"];
  /** Genability tariff (Rate) code */
  tariffCode: Scalars["String"];
  /** Genability tariff Id */
  tariffId: Scalars["String"];
  /** Genability tariff (Rate) name */
  tariffName: Scalars["String"];
  /** Genability time zone */
  timeZone: Scalars["String"];
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"];
  /** ID of utility company */
  utilityCompanyId: Scalars["String"];
};

export type UtilityRateFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]>;
};

export type UtilityRateInput = {
  filter?: InputMaybe<UtilityRateFindManyWhereInput>;
  paginate?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UtilityRateOrderByInput>;
};

export type UtilityRateOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>;
};
